﻿// @ts-nocheck
/**
 * Nexode Pro Template（自定义元素 `nexode-pro-template-section`）
 *
 * KV：双视频断点切换 + 封面渐隐，逻辑对齐 nexode-air-template。
 * KV 二级导航：滚过 KV 后滑入；手机端第二行下滑收起、上滑展开。
 */
(function () {
  'use strict';

  const TAG_NAME = 'nexode-pro-template-section';
  const MOBILE_MQ = '(max-width: 1023.98px)';
  /** 留邮提交（对齐 new-nexode-pro） */
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';
  /** 页面内轮播自动切换间隔（场景等） */
  const NPT_CAROUSEL_AUTOPLAY_MS = 6000;
  /** 功能卡展开图 open-slider 自动切换（3 秒） */
  const NPT_FEATURES_OPEN_SLIDER_MS = 3000;
  /** GA4 埋点页面标识 */
  const NPT_TRACK_POSITION = 'nexode-pro-template';
  /**
   * ScrollTrigger scrub 缓动秒数（对齐 Air pack 0.35 手感）
   * true=硬跟手易抖；数值=滚动与动画插值，整页更丝滑
   */
  const NPT_SCRUB = 0.4;
  /** 锚点跳转：目标位置相对导航底边再留隙，并略向下多滚一点 */
  const NPT_KV_NAV_ANCHOR_GAP_BELOW_NAV_PX = 8;
  const NPT_KV_NAV_ANCHOR_EXTRA_SCROLL_PX = 20;
  /** 手机端判定滚动方向的最小位移，避免抖动误触 */
  const NPT_KV_NAV_SCROLL_DIR_THRESHOLD_PX = 6;
  /** 页内锚点：相对 kv-nav 高度定位滚动（一图瞥 / 二级导航共用） */
  function nptJumpToPageAnchor(targetEl, navEl, reducedMotion) {
    if (!(targetEl instanceof HTMLElement)) return;
    const sy = window.scrollY || window.pageYOffset || 0;
    const navH =
      navEl instanceof HTMLElement ? Math.max(0, Math.round(navEl.getBoundingClientRect().height)) : 0;
    const targetTop = targetEl.getBoundingClientRect().top + sy;
    const nextTop = Math.max(
      0,
      targetTop - navH - NPT_KV_NAV_ANCHOR_GAP_BELOW_NAV_PX + NPT_KV_NAV_ANCHOR_EXTRA_SCROLL_PX
    );
    window.scrollTo({
      top: nextTop,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  function nptGetHashFromHref(href) {
    if (typeof href !== 'string' || href.length === 0) return '';
    if (href.startsWith('#')) return href;
    try {
      const url = new URL(href, window.location.href);
      return url.hash || '';
    } catch (_) {
      return '';
    }
  }

  function nptGetTargetByHash(hash, root) {
    if (typeof hash !== 'string' || !hash.startsWith('#')) return null;
    const target =
      (root instanceof HTMLElement ? root.querySelector(hash) : null) || document.querySelector(hash);
    return target instanceof HTMLElement ? target : null;
  }

  /** 优先 data-npt-scroll-target（CSS 选择器），否则走 hash */
  function nptResolveScrollTarget(link, root) {
    if (!(link instanceof Element)) return null;
    const sel = (link.getAttribute('data-npt-scroll-target') || '').trim();
    if (sel) {
      try {
        const el =
          (root instanceof HTMLElement ? root.querySelector(sel) : null) || document.querySelector(sel);
        if (el instanceof HTMLElement) return el;
      } catch (_) {}
    }
    return nptGetTargetByHash(nptGetHashFromHref(link.getAttribute('href') || ''), root);
  }

  /** YouTube URL → embed（带 autoplay） */
  function nptNormalizeYoutubeEmbed(rawUrl) {
    const url = String(rawUrl || '').trim();
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      let id = '';
      if (parsed.hostname.includes('youtu.be')) {
        id = parsed.pathname.replace(/^\//, '').split('/')[0] || '';
      } else if (parsed.hostname.includes('youtube.com')) {
        if (parsed.pathname.startsWith('/embed/')) {
          id = parsed.pathname.split('/')[2] || '';
        } else if (parsed.pathname.startsWith('/shorts/')) {
          id = parsed.pathname.split('/')[2] || '';
        } else {
          id = parsed.searchParams.get('v') || '';
        }
      }
      if (!id) {
        if (/^[a-zA-Z0-9_-]{6,}$/.test(url)) return `https://www.youtube.com/embed/${url}?autoplay=1&rel=0&playsinline=1`;
        return '';
      }
      return `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
    } catch (_) {
      return '';
    }
  }

  /**
   * 全宽 % 轮播：箭头 + 填充进度 + 拖拽切换 + 视口内自动播放
   * （features-mo / safe-mo / flagship-features-mo）
   * @param {{
   *   viewport: HTMLElement,
   *   track: HTMLElement,
   *   slides: HTMLElement[],
   *   prevBtn: Element|null,
   *   nextBtn: Element|null,
   *   progress: Element|null,
   *   progressFillClass: string,
   *   cleanups: Function[],
   * }} opts
   */
  function nptBindPercentCarousel(opts) {
    const { viewport, track, slides, prevBtn, nextBtn, progress, progressFillClass, cleanups } = opts;
    if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !slides.length) return;

    let progressFill = null;
    if (progress instanceof HTMLElement) {
      progressFill = document.createElement('span');
      progressFill.className = progressFillClass;
      progress.replaceChildren(progressFill);
    }

    let index = 0;
    const max = slides.length - 1;
    /* 阿语首张在右，向左翻；位移用正值，避免百分比在 RTL 里翻空 */
    const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
    const shiftPercent = (/** @type {number} */ slideIndex) => (isRtl ? slideIndex : -slideIndex) * 100;
    let isDragging = false;
    let dragPointerId = null;
    let dragStartX = 0;
    let dragDeltaX = 0;
    let autoTimer = 0;
    let inView = false;
    const reduced = nptPrefersReducedMotion();

    const sync = () => {
      track.style.transform = `translate3d(${shiftPercent(index)}%, 0, 0)`;
      if (progressFill instanceof HTMLElement) {
        progressFill.style.width = `${((index + 1) / slides.length) * 100}%`;
      }
      if (prevBtn instanceof HTMLElement) {
        const atStart = index <= 0;
        prevBtn.disabled = atStart;
        prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (nextBtn instanceof HTMLElement) {
        const atEnd = index >= max;
        nextBtn.disabled = atEnd;
        nextBtn.classList.toggle('is-disabled', atEnd);
      }
    };

    const go = (/** @type {number} */ next) => {
      index = Math.max(0, Math.min(max, next));
      sync();
    };

    const clearAutoPlay = () => {
      if (autoTimer) {
        window.clearInterval(autoTimer);
        autoTimer = 0;
      }
    };

    const startAutoPlay = () => {
      clearAutoPlay();
      if (!inView || slides.length <= 1 || reduced) return;
      autoTimer = window.setInterval(() => {
        /* 到尾回首，手机端可持续轮播 */
        go(index >= max ? 0 : index + 1);
      }, NPT_CAROUSEL_AUTOPLAY_MS);
    };

    const restartAutoPlay = () => {
      startAutoPlay();
    };

    if (prevBtn instanceof HTMLElement) {
      const onPrev = () => {
        go(index - 1);
        restartAutoPlay();
      };
      prevBtn.addEventListener('click', onPrev);
      cleanups.push(() => prevBtn.removeEventListener('click', onPrev));
    }
    if (nextBtn instanceof HTMLElement) {
      const onNext = () => {
        go(index + 1);
        restartAutoPlay();
      };
      nextBtn.addEventListener('click', onNext);
      cleanups.push(() => nextBtn.removeEventListener('click', onNext));
    }

    if (slides.length > 1) {
      const onPointerDown = (ev) => {
        if (!(ev instanceof PointerEvent)) return;
        const targetEl = ev.target instanceof Element ? ev.target : null;
        if (targetEl && targetEl.closest('a, button')) return;
        if (ev.pointerType === 'mouse' && ev.button !== 0) return;
        clearAutoPlay();
        isDragging = true;
        dragPointerId = ev.pointerId;
        dragStartX = ev.clientX;
        dragDeltaX = 0;
        track.style.transition = 'none';
        viewport.classList.add('is-npt-dragging');
        try {
          viewport.setPointerCapture(ev.pointerId);
        } catch (_) {}
        ev.preventDefault();
      };

      const onPointerMove = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) return;
        dragDeltaX = ev.clientX - dragStartX;
        const base = (isRtl ? index : -index) * viewport.clientWidth;
        track.style.transform = `translate3d(${base + dragDeltaX}px, 0, 0)`;
      };

      const finishDrag = (ev) => {
        if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) return;
        isDragging = false;
        dragPointerId = null;
        viewport.classList.remove('is-npt-dragging');
        try {
          viewport.releasePointerCapture(ev.pointerId);
        } catch (_) {}
        track.style.removeProperty('transition');
        const threshold = Math.max(40, viewport.clientWidth * 0.08);
        if (Math.abs(dragDeltaX) >= threshold) {
          /* 阿语下一张在左侧，向右拖才是前进 */
          const forward = isRtl ? dragDeltaX > 0 : dragDeltaX < 0;
          go(index + (forward ? 1 : -1));
        } else {
          sync();
        }
        dragDeltaX = 0;
        restartAutoPlay();
      };

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      cleanups.push(() => viewport.removeEventListener('pointerdown', onPointerDown));
      cleanups.push(() => viewport.removeEventListener('pointermove', onPointerMove));
      cleanups.push(() => viewport.removeEventListener('pointerup', finishDrag));
      cleanups.push(() => viewport.removeEventListener('pointercancel', finishDrag));
    }

    const onVisibilityChange = () => {
      if (document.hidden) clearAutoPlay();
      else startAutoPlay();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    cleanups.push(() => document.removeEventListener('visibilitychange', onVisibilityChange));

    cleanups.push(
      nptObserveInView(viewport, (visible) => {
        inView = visible;
        if (visible) startAutoPlay();
        else clearAutoPlay();
      })
    );
    cleanups.push(clearAutoPlay);

    sync();
  }

  function nptPrefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {
      return false;
    }
  }

  /**
   * 进入/离开视窗时回调；无 IO 时视为已在视口。
   * @param {(visible: boolean) => void} onChange
   * @param {{ threshold?: number }} [opts]
   * @returns {() => void}
   */
  function nptObserveInView(el, onChange, opts) {
    if (!(el instanceof Element) || typeof onChange !== 'function') return () => {};
    if (typeof IntersectionObserver !== 'function') {
      onChange(true);
      return () => {};
    }
    const threshold = opts && typeof opts.threshold === 'number' ? opts.threshold : 0.15;
    const io = new IntersectionObserver(
      (entries) => {
        onChange(entries.some((e) => e.isIntersecting));
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }

  /** 按需注入脚本（首屏不阻塞下载 GSAP）*/
  function nptLoadScriptOnce(src) {
    const url = String(src || '').trim();
    if (!url) return Promise.resolve();
    const existing = document.querySelector(`script[data-npt-lib="${url}"]`);
    if (existing) {
      if (existing.dataset.nptLoaded === '1') return Promise.resolve();
      return new Promise((resolve, reject) => {
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error('script')), { once: true });
      });
    }
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.dataset.nptLib = url;
      s.addEventListener(
        'load',
        () => {
          s.dataset.nptLoaded = '1';
          resolve();
        },
        { once: true }
      );
      s.addEventListener('error', () => reject(new Error('script')), { once: true });
      document.head.appendChild(s);
    });
  }

  /** 从 section 上 data-npt-gsap-src / data-npt-st-src 拉取动效库 */
  function nptEnsureMotionLibs(host) {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    if (nptEnsureMotionLibs._p) return nptEnsureMotionLibs._p;
    const root = host instanceof HTMLElement ? host : document.querySelector('[data-npt-root]');
    const gsapSrc = root && root.getAttribute('data-npt-gsap-src');
    const stSrc = root && root.getAttribute('data-npt-st-src');
    nptEnsureMotionLibs._p = nptLoadScriptOnce(gsapSrc)
      .then(() => nptLoadScriptOnce(stSrc))
      .catch(() => {
        nptEnsureMotionLibs._p = null;
      });
    return nptEnsureMotionLibs._p || Promise.resolve();
  }

  /** GSAP / ScrollTrigger 就绪；返回取消函数*/
  function nptWhenGsapReady(onReady) {
    let cancelled = false;
    let timer = 0;
    const cancel = () => {
      cancelled = true;
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };
    const attempt = () => {
      if (cancelled) return true;
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return false;
      gsap.registerPlugin(ScrollTrigger);
      /* 全局默认：不提前 pin，减少顶缝抖动（对齐 Air） */
      if (!ScrollTrigger._nptDefaultsApplied) {
        ScrollTrigger.defaults({ anticipatePin: 0 });
        ScrollTrigger.config({ ignoreMobileResize: true });
        ScrollTrigger._nptDefaultsApplied = true;
      }
      onReady(gsap, ScrollTrigger);
      return true;
    };
    nptEnsureMotionLibs(document.querySelector('[data-npt-root]'));
    if (attempt()) return cancel;
    let tries = 0;
    timer = window.setInterval(() => {
      if (cancelled) return;
      tries += 1;
      if (attempt() || tries >= 80) {
        window.clearInterval(timer);
        timer = 0;
      }
    }, 50);
    return cancel;
  }

  function nptIsCalloutLeft(el) {
    return el.classList.contains('ug-nexode-pro-template__showcase-callout--side-l');
  }

  function nptStageParts(stage) {
    return {
      stage,
      title: stage.querySelector('.ug-nexode-pro-template__showcase-stage-title'),
      product: stage.querySelector('.ug-nexode-pro-template__showcase-stage-product'),
      disclaimer: stage.querySelector('.ug-nexode-pro-template__showcase-stage-disclaimer'),
      callouts: Array.from(stage.querySelectorAll('.ug-nexode-pro-template__showcase-callout')),
    };
  }

  function nptCalloutBits(callout) {
    return {
      card: callout.querySelector('.ug-nexode-pro-template__showcase-callout-card'),
      line: callout.querySelector('.ug-nexode-pro-template__showcase-callout-line'),
      dot: callout.querySelector('.ug-nexode-pro-template__showcase-callout-dot'),
    };
  }

  /** 卖点卡：中间往两边（左 +40 / 右 -40）*/
  function nptCalloutCardFromX(callout) {
    return nptIsCalloutLeft(callout) ? 40 : -40;
  }

  /** 智能屏显：收集 panel 内可动元素（文案 + panels 外共用） */
  function nptDisplayPanelParts(panel) {
    const root = panel.closest('[data-npt-display]') || panel;
    const copy = root.querySelector('.ug-nexode-pro-template__display-copy');
    return {
      panel,
      stage: panel.querySelector('.ug-nexode-pro-template__display-stage'),
      desk: panel.querySelector('.ug-nexode-pro-template__display-desk'),
      title: copy ? copy.querySelector('.ug-nexode-pro-template__display-title') : null,
      desc: copy ? copy.querySelector('.ug-nexode-pro-template__display-desc') : null,
      floats: Array.from(panel.querySelectorAll('.ug-nexode-pro-template__display-float')),
      product: panel.querySelector('.ug-nexode-pro-template__display-product'),
      mo: panel.querySelector('.ug-nexode-pro-template__display-mo'),
    };
  }

  /** 屏显入场：不规则节拍（相对时间轴 0~1）；文案常显，不参与 scrub */
  const NPT_DISPLAY_ENTER_BEATS = [
    { kind: 'float', index: 1, at: 0.1 },
    { kind: 'float', index: 4, at: 0.16 },
    { kind: 'float', index: 2, at: 0.26 },
    { kind: 'product', at: 0.3 },
    { kind: 'mo', at: 0.22 },
    { kind: 'float', index: 3, at: 0.42 },
    { kind: 'float', index: 0, at: 0.52 },
    { kind: 'float', index: 5, at: 0.64 },
  ];

  function nptDisplayResolveBeatEl(parts, beat) {
    if (beat.kind === 'product') return parts.product;
    if (beat.kind === 'mo') return parts.mo;
    if (beat.kind === 'float') return parts.floats[beat.index] || null;
    return null;
  }

  function nptDisplayBeatFromVars(beat, yScale) {
    const s = yScale == null ? 1 : yScale;
    if (beat.kind === 'product') return { opacity: 0, y: 72 * s };
    if (beat.kind === 'mo') return { opacity: 0, y: 48 * s };
    return { opacity: 0, y: 52 * s };
  }

  function nptDisplayBeatToVars(beat) {
    return { opacity: 1, y: 0 };
  }

  function nptHexToRgb(hex) {
    const s = String(hex || '').replace('#', '');
    return [parseInt(s.slice(0, 2), 16), parseInt(s.slice(2, 4), 16), parseInt(s.slice(4, 6), 16)];
  }

  function nptLerpHex(a, b, t) {
    const ca = nptHexToRgb(a);
    const cb = nptHexToRgb(b);
    const p = Math.min(1, Math.max(0, t));
    const ch = (i) => Math.round(ca[i] + (cb[i] - ca[i]) * p);
    return `#${[ch(0), ch(1), ch(2)].map((n) => n.toString(16).padStart(2, '0')).join('')}`;
  }

  /** GA4：按钮点击 click_button */
  function nptTrackClickButton(button_name, extra) {
    const track = window.ugGa4Track;
    if (!track || typeof track.clickButton !== 'function') return;
    try {
      track.clickButton({
        module: NPT_TRACK_POSITION,
        button_name,
        ...(extra && typeof extra === 'object' ? extra : {}),
      });
    } catch (_) {}
  }

  /** GA4：从 DOM 读取 data-ga4-product */
  function nptGa4ItemsFromEl(el) {
    const track = window.ugGa4Track;
    if (!track || typeof track.itemsFromElement !== 'function') return [];
    try {
      return track.itemsFromElement(el) || [];
    } catch (_) {
      return [];
    }
  }

  /** GA4：商品点击 select_item */
  function nptTrackSelectItem(el, button_name) {
    const track = window.ugGa4Track;
    const items = nptGa4ItemsFromEl(el);
    if (!items.length || !track || typeof track.selectItem !== 'function') return;
    try {
      track.selectItem({
        button_name,
        currency: track.getCurrency ? track.getCurrency() : 'USD',
        items,
      });
    } catch (_) {}
  }

  /** 静音 + playsInline，保障 iOS 自动播放 */
  function nptPrimeInlineVideoForAutoplay(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    } catch (_) {}
  }

  /** 静音内联视频自动播放（双 rAF） */
  function nptPlayInlineVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    nptPrimeInlineVideoForAutoplay(video);
    const run = () => {
      if (!video.isConnected) return;
      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    };
    const schedulePlay = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    };
    if (video.readyState >= 2) {
      schedulePlay();
      return;
    }
    const once = () => {
      if (!video.isConnected) return;
      schedulePlay();
    };
    video.addEventListener('loadeddata', once, { once: true });
    video.addEventListener('canplay', once, { once: true });
  }

  /** 暂停内联视频；可选卸 src 以释放解码（保留 data-npt-video-src 以便恢复） */
  function nptPauseInlineVideo(video, unload) {
    if (!(video instanceof HTMLVideoElement)) return;
    try {
      video.pause();
    } catch (_) {}
    if (!unload) return;
    const srcAttr = video.getAttribute('src');
    const source = video.querySelector('source');
    const sourceSrc = source && source.getAttribute('src');
    const current = srcAttr || sourceSrc || '';
    if (current) video.dataset.nptVideoSrc = current;
    try {
      if (srcAttr) {
        video.removeAttribute('src');
        video.load();
      } else if (source && sourceSrc) {
        source.removeAttribute('src');
        video.load();
      }
    } catch (_) {}
  }

  /** 恢复被卸掉的 src 后播放 */
  function nptRestoreAndPlayInlineVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    const saved = video.dataset.nptVideoSrc || '';
    if (saved) {
      const source = video.querySelector('source');
      if (source) {
        if (!source.getAttribute('src')) source.setAttribute('src', saved);
      } else if (!video.getAttribute('src')) {
        video.setAttribute('src', saved);
      }
      try {
        video.load();
      } catch (_) {}
    }
    nptPlayInlineVideo(video);
  }

  /**
   * 进视口播放 / 离视口暂停；复用主题全局 Swiper 同思路，统一视频策略。
   * @returns {() => void}
   */
  function nptBindViewportVideo(video, opts) {
    if (!(video instanceof HTMLVideoElement)) return () => {};
    const observeEl =
      opts && opts.observeEl instanceof Element ? opts.observeEl : video;
    const unload = !!(opts && opts.unloadOnHide);
    const threshold =
      opts && typeof opts.threshold === 'number' ? opts.threshold : 0.12;
    const onVisible =
      opts && typeof opts.onVisible === 'function' ? opts.onVisible : null;
    const onHidden =
      opts && typeof opts.onHidden === 'function' ? opts.onHidden : null;

    return nptObserveInView(
      observeEl,
      (visible) => {
        if (visible) {
          if (onVisible) onVisible();
          else nptRestoreAndPlayInlineVideo(video);
        } else {
          if (onHidden) onHidden();
          else nptPauseInlineVideo(video, unload);
        }
      },
      { threshold }
    );
  }

  /** 阿语页让 Swiper 从右起，配合两侧按钮对调 */
  function nptMarkSwiperRtl(el) {
    if (!(el instanceof HTMLElement)) return;
    if (document.documentElement.getAttribute('dir') !== 'rtl') return;
    el.setAttribute('dir', 'rtl');
  }

  /** 等待主题全局 `window.Swiper`（scripts.liquid 已 defer，勿重复加载） */
  function nptWhenSwiperReady(onReady) {
    let cancelled = false;
    let timer = 0;
    const cancel = () => {
      cancelled = true;
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };
    const attempt = () => {
      if (cancelled) return true;
      const SwiperCtor = window.Swiper;
      if (typeof SwiperCtor !== 'function') return false;
      onReady(SwiperCtor);
      return true;
    };
    if (attempt()) return cancel;
    let tries = 0;
    timer = window.setInterval(() => {
      if (cancelled) return;
      tries += 1;
      if (attempt() || tries >= 80) {
        window.clearInterval(timer);
        timer = 0;
      }
    }, 50);
    return cancel;
  }

  class NexodeProTemplateSection extends HTMLElement {
    constructor() {
      super();
      this._onVideoResize = null;
      this._kvResizeRaf = 0;
      /** @type {Array<() => void>} */
      this._navCleanups = [];
      /** @type {Array<() => void>} */
      this._showcaseCleanups = [];
    }

    connectedCallback() {
      if (this.dataset.nptInited === '1') return;
      this.dataset.nptInited = '1';
      /* 首屏无关：空闲时再拉 GSAP，缩短主线程抢占 */
      const bootMotion = () => {
        nptEnsureMotionLibs(this);
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(bootMotion, { timeout: 900 });
      } else {
        window.setTimeout(bootMotion, 0);
      }
      this.initKvVideo();
      this.initKvNav();
      this.initShowcase();
      this.initScenes();
      this.initSeriesGlance();
      this.initGlanceLoopVideo();
      this.initInsideTitle();
      this.initFlagshipOutput();
      this.initDisplayTabs();
      this.initDisplayEyebrow();
      this.initFeatureCards();
      this.initSafeDurable();
      this.initSafeTitle();
      this.initAchievements();
      this.initLogoMarquee();
      this.initSubscribe();
      this.initBuyDropdowns();
      this.initNptAnalytics();
      this.dispatchEvent(
        new CustomEvent('ug:npt:ready', {
          bubbles: true,
          detail: { mobile: window.matchMedia(MOBILE_MQ).matches },
        })
      );
    }

    disconnectedCallback() {
      if (this._kvResizeRaf) {
        window.cancelAnimationFrame(this._kvResizeRaf);
        this._kvResizeRaf = 0;
      }
      if (this._kvRevealFallbackTimer) {
        window.clearTimeout(this._kvRevealFallbackTimer);
        this._kvRevealFallbackTimer = 0;
      }
      if (this._onVideoResize) {
        window.removeEventListener('resize', this._onVideoResize);
        this._onVideoResize = null;
      }
      this.dataset.nptVideoResizeBound = '0';
      this._runCleanups(this._kvVideoCleanups || (this._kvVideoCleanups = []));
      this.querySelectorAll('video').forEach((v) => {
        try {
          v.pause();
        } catch (_) {}
      });
      this._nptPlayGlanceLoopVideo = null;
      this._teardownKvNav();
      this._teardownShowcase();
      this._teardownScenes();
      this._teardownSeriesReveal();
      this._teardownInsideTitle();
      this._teardownDisplayTabs();
      this._teardownDisplayEyebrow();
      this._teardownFeatureCards();
      this._teardownFlagship();
      this._teardownSafeDurable();
      this._teardownSafeTitle();
      this._teardownAchievements();
      this._teardownLogoMarquee();
      this._teardownSubscribe();
      this._teardownAnalytics();
      delete this.dataset.nptInited;
    }

    _runCleanups(list) {
      while (list.length) {
        const fn = list.pop();
        try {
          if (typeof fn === 'function') fn();
        } catch (_) {}
      }
    }

    _teardownKvNav() {
      this._runCleanups(this._navCleanups);
    }

    _teardownShowcase() {
      this._runCleanups(this._showcaseCleanups);
    }

    _teardownScenes() {
      this._runCleanups(this._scenesCleanups || (this._scenesCleanups = []));
    }

    _teardownSeriesReveal() {
      this._runCleanups(this._seriesRevealCleanups || (this._seriesRevealCleanups = []));
    }

    _teardownInsideTitle() {
      this._runCleanups(this._insideTitleCleanups || (this._insideTitleCleanups = []));
    }

    _teardownDisplayTabs() {
      this._runCleanups(this._displayTabsCleanups || (this._displayTabsCleanups = []));
    }

    _teardownDisplayEyebrow() {
      this._runCleanups(this._displayEyebrowCleanups || (this._displayEyebrowCleanups = []));
    }

    _teardownFeatureCards() {
      this._runCleanups(this._featureCardsCleanups || (this._featureCardsCleanups = []));
    }

    _teardownSafeDurable() {
      this._runCleanups(this._safeDurableCleanups || (this._safeDurableCleanups = []));
    }

    _teardownSafeTitle() {
      this._runCleanups(this._safeTitleCleanups || (this._safeTitleCleanups = []));
    }

    _teardownAchievements() {
      this._runCleanups(this._achievementsCleanups || (this._achievementsCleanups = []));
    }

    _teardownLogoMarquee() {
      this._runCleanups(this._logoMarqueeCleanups || (this._logoMarqueeCleanups = []));
    }

    _teardownFlagship() {
      this._runCleanups(this._flagshipCleanups || (this._flagshipCleanups = []));
    }

    _teardownSubscribe() {
      this._runCleanups(this._subscribeCleanups || (this._subscribeCleanups = []));
    }

    _teardownAnalytics() {
      this._runCleanups(this._analyticsCleanups || (this._analyticsCleanups = []));
    }
    /** 页内点击埋点：导航 / 卡片等 */
    initNptAnalytics() {
      this._analyticsCleanups = this._analyticsCleanups || [];
      this._runCleanups(this._analyticsCleanups);
      const cleanups = this._analyticsCleanups;

      const onClick = (e) => {
        if (!this.isConnected) return;
        const target = e.target;
        if (!(target instanceof Element)) return;

        /* KV 二级导航锚点 */
        const kvAnchor = target.closest('[data-npt-kv-nav-anchor]');
        if (kvAnchor instanceof HTMLElement && this.contains(kvAnchor)) {
          nptTrackClickButton('kv_nav_anchor', {
            navigation_name: (kvAnchor.textContent || '').trim(),
          });
          return;
        }

        /* KV 导航 Buy */
        const kvBuy = target.closest('[data-npt-kv-nav-buy]');
        if (kvBuy instanceof HTMLElement && this.contains(kvBuy)) {
          nptTrackClickButton('kv_nav_buy');
          return;
        }

        /* 一图懂卡片 */
        const glanceAnchor = target.closest('[data-npt-glance-anchor]');
        if (glanceAnchor instanceof HTMLElement && this.contains(glanceAnchor)) {
          nptTrackClickButton('glance_card');
          return;
        }

        /* Showcase 整卡跳转商详 */
        const cardHit = target.closest('.ug-nexode-pro-template__showcase-card-hit');
        if (cardHit instanceof HTMLAnchorElement && this.contains(cardHit)) {
          nptTrackSelectItem(cardHit, 'product_card');
          return;
        }
      };

      this.addEventListener('click', onClick, true);
      cleanups.push(() => this.removeEventListener('click', onClick, true));
    }
    /** 留邮订阅：校验 + Cirkle 提交（对齐 new-nexode-pro） */
    initSubscribe() {
      this._subscribeCleanups = this._subscribeCleanups || [];
      this._runCleanups(this._subscribeCleanups);
      const cleanups = this._subscribeCleanups;

      this.querySelectorAll('[data-npt-email]').forEach((block) => {
        if (!(block instanceof HTMLElement)) return;
        if (block.dataset.nptEmailInited === '1') return;
        block.dataset.nptEmailInited = '1';

        const submitBtn = block.querySelector('.ug-nexode-pro-template__subscribe-email-submit');
        const input = block.querySelector('.ug-nexode-pro-template__subscribe-email-input');
        const privacyCheckbox = block.querySelector('.ug-nexode-pro-template__subscribe-email-checkbox');
        const errorMsg = block.querySelector('.ug-nexode-pro-template__subscribe-email-error');
        const successMsg = block.querySelector('.ug-nexode-pro-template__subscribe-email-message');

        const formId = block.getAttribute('data-form-id') || '';
        const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
        const failText =
          block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
        const privacyError =
          block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.';
        const emailError =
          block.getAttribute('data-email-error') || 'Please enter a valid email address.';

        if (!(submitBtn instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) {
          delete block.dataset.nptEmailInited;
          return;
        }

        const showError = (msg) => {
          if (errorMsg instanceof HTMLElement) {
            errorMsg.textContent = msg;
            errorMsg.style.display = 'block';
          }
          if (successMsg instanceof HTMLElement) {
            successMsg.style.display = 'none';
          }
        };

        const showSuccess = (msg) => {
          if (successMsg instanceof HTMLElement) {
            successMsg.textContent = msg;
            successMsg.style.display = 'block';
          }
          if (errorMsg instanceof HTMLElement) {
            errorMsg.style.display = 'none';
          }
        };

        const trackSubscription = (isSuccess) => {
          const w = window;
          if (!w.ugGa4Track || typeof w.ugGa4Track.subscriptionEvent !== 'function') return;
          try {
            w.ugGa4Track.subscriptionEvent({ isSuccess, position: 'nexode-pro-template' });
          } catch (_) {}
        };

        const onSubmit = async () => {
          const emailVal = input.value.trim();
          const emailOk =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              String(emailVal).toLowerCase()
            );

          if (!emailOk) {
            showError(emailError);
            return;
          }

          if (privacyCheckbox instanceof HTMLInputElement && !privacyCheckbox.checked) {
            showError(privacyError);
            return;
          }

          if (!formId) {
            showError(failText);
            return;
          }

          if (errorMsg instanceof HTMLElement) errorMsg.style.display = 'none';
          if (successMsg instanceof HTMLElement) successMsg.style.display = 'none';
          if (submitBtn.classList.contains('loading')) return;

          submitBtn.classList.add('loading');

          const ac = typeof AbortController === 'function' ? new AbortController() : null;
          const abortTimer = ac
            ? window.setTimeout(() => {
                try {
                  ac.abort();
                } catch (_) {}
              }, 15000)
            : 0;

          try {
            const response = await fetch(FORM_SUBMIT_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: emailVal,
                accepts_marketing:
                  privacyCheckbox instanceof HTMLInputElement && privacyCheckbox.checked
                    ? 'on'
                    : 'off',
                form_id: formId,
              }),
              signal: ac ? ac.signal : undefined,
            });

            if (!this.isConnected) return;

            let data = null;
            try {
              data = await response.json();
            } catch (_) {
              showError(failText);
              trackSubscription(false);
              return;
            }

            const isSuccess = data && data.status === 'success';
            if (isSuccess) {
              input.value = '';
              showSuccess(successText);
            } else {
              const serverMsg =
                (data && data.errors && data.errors.email && data.errors.email[0]) ||
                (data && data.message) ||
                failText;
              showError(serverMsg);
            }
            trackSubscription(!!isSuccess);
          } catch (_) {
            if (!this.isConnected) return;
            showError(failText);
            trackSubscription(false);
          } finally {
            if (abortTimer) window.clearTimeout(abortTimer);
            if (this.isConnected) submitBtn.classList.remove('loading');
          }
        };

        const onKeydown = (e) => {
          if (e instanceof KeyboardEvent && e.key === 'Enter') {
            e.preventDefault();
            submitBtn.click();
          }
        };

        submitBtn.addEventListener('click', onSubmit);
        input.addEventListener('keydown', onKeydown);
        cleanups.push(() => {
          submitBtn.removeEventListener('click', onSubmit);
          input.removeEventListener('keydown', onKeydown);
          delete block.dataset.nptEmailInited;
        });
      });
    }

    /** 成就数据：PC Swiper + 手机手风琴 */
    initAchievements() {
      this._achievementsCleanups = this._achievementsCleanups || [];
      this._runCleanups(this._achievementsCleanups);
      const cleanups = this._achievementsCleanups;

      this.querySelectorAll('[data-npt-achievements]').forEach((root) => {
        if (!(root instanceof HTMLElement)) return;

        const desk = root.querySelector('[data-npt-achievements-desk]');
        const prevBtn = root.querySelector('[data-npt-achievements-prev]');
        const nextBtn = root.querySelector('[data-npt-achievements-next]');
        const moCards = Array.from(root.querySelectorAll('[data-npt-achievements-mo-card]')).filter(
          (el) => el instanceof HTMLElement
        );

        moCards.forEach((card) => {
          const btn = card.querySelector('[data-npt-achievements-mo-toggle]');
          if (!(btn instanceof HTMLElement)) return;
          const onToggle = () => {
            const open = card.classList.contains('is-open');
            moCards.forEach((c) => c.classList.remove('is-open'));
            if (!open) card.classList.add('is-open');
          };
          btn.addEventListener('click', onToggle);
          cleanups.push(() => btn.removeEventListener('click', onToggle));
        });

        if (!(desk instanceof HTMLElement)) return;
        /* 复用主题全局 Swiper（勿二次加载） */
        const cancelSwiperWait = nptWhenSwiperReady((SwiperCtor) => {
          if (!this.isConnected || !desk.isConnected) return;
          nptMarkSwiperRtl(desk);
          const swiper = new SwiperCtor(desk, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: 800,
            grabCursor: true,
            navigation: {
              prevEl: prevBtn instanceof HTMLElement ? prevBtn : undefined,
              nextEl: nextBtn instanceof HTMLElement ? nextBtn : undefined,
            },
            on: {
              init(sw) {
                if (prevBtn instanceof HTMLElement) prevBtn.disabled = sw.isBeginning;
                if (nextBtn instanceof HTMLElement) nextBtn.disabled = sw.isEnd;
              },
              slideChange(sw) {
                if (prevBtn instanceof HTMLElement) prevBtn.disabled = sw.isBeginning;
                if (nextBtn instanceof HTMLElement) nextBtn.disabled = sw.isEnd;
              },
            },
          });
          cleanups.push(() => {
            try {
              swiper.destroy(true, true);
            } catch (_) {}
          });
        });
        cleanups.push(cancelSwiperWait);
      });
    }

    /** Logo 无限滚动 */
    initLogoMarquee() {
      this._logoMarqueeCleanups = this._logoMarqueeCleanups || [];
      this._runCleanups(this._logoMarqueeCleanups);
      const cleanups = this._logoMarqueeCleanups;
      const reduced = nptPrefersReducedMotion();

      this.querySelectorAll('[data-npt-logos]').forEach((root) => {
        if (!(root instanceof HTMLElement)) return;
        const track = root.querySelector('[data-npt-logos-track]');
        if (!(track instanceof HTMLElement)) return;

        const items = Array.from(track.children);
        if (!items.length) return;

        if (reduced) return;

        /* reinit 时勿重复克隆，否则节点翻倍 */
        if (track.dataset.nptMarqueeCloned !== '1') {
          items.forEach((item) => {
            track.appendChild(item.cloneNode(true));
          });
          track.dataset.nptMarqueeCloned = '1';
        }

        const speed = 20;
        let position = 0;
        let paused = false;
        let inView = false;
        let raf = 0;

        const onEnter = () => {
          paused = true;
        };
        const onLeave = () => {
          paused = false;
        };
        track.querySelectorAll('img').forEach((img) => {
          img.addEventListener('mouseenter', onEnter);
          img.addEventListener('mouseleave', onLeave);
          cleanups.push(() => {
            img.removeEventListener('mouseenter', onEnter);
            img.removeEventListener('mouseleave', onLeave);
          });
        });

        const stopRaf = () => {
          if (raf) {
            window.cancelAnimationFrame(raf);
            raf = 0;
          }
        };

        const tick = () => {
          raf = 0;
          if (!inView) return;
          if (!paused) {
            position -= speed / 60;
            const first = track.children[0];
            if (first instanceof HTMLElement) {
              const w = first.getBoundingClientRect().width;
              if (w > 0 && Math.abs(position) >= w) {
                track.appendChild(first);
                position += w;
              }
            }
            track.style.transform = `translate3d(${position}px,0,0)`;
          }
          raf = window.requestAnimationFrame(tick);
        };

        const startRaf = () => {
          if (!raf) raf = window.requestAnimationFrame(tick);
        };

        cleanups.push(
          nptObserveInView(root, (visible) => {
            inView = visible;
            if (visible) startRaf();
            else stopRaf();
          })
        );
        cleanups.push(stopRaf);
      });
    }

    /** 智能屏显眉标题滚动渐变：0 → 1 → 0*/
    initDisplayEyebrow() {
      this._displayEyebrowCleanups = this._displayEyebrowCleanups || [];
      this._runCleanups(this._displayEyebrowCleanups);

      const section = this.querySelector('[data-npt-display]');
      const title = section
        ? section.querySelector('[data-npt-display-eyebrow]')
        : null;
      if (!(section instanceof HTMLElement) || !(title instanceof HTMLElement)) return;

      const C0_START = '#1F1F1F';
      const C1_START = '#335E96';
      const C0_END = '#BBDAF8';
      const C1_END = '#FFFFFF';

      const paintProgress = (t) => {
        const bg = `linear-gradient(0deg, ${nptLerpHex(C0_START, C0_END, t)} 0%, ${nptLerpHex(C1_START, C1_END, t)} 100%)`;
        const apply = (el) => {
          el.style.backgroundImage = bg;
          el.style.backgroundRepeat = 'no-repeat';
          el.style.backgroundSize = '100% 100%';
          el.style.webkitBackgroundClip = 'text';
          el.style.backgroundClip = 'text';
          el.style.color = 'transparent';
          el.style.webkitTextFillColor = 'transparent';
        };
        apply(title);
        title.querySelectorAll('p, span, strong, em, b, i').forEach(apply);
      };

      if (nptPrefersReducedMotion()) {
        paintProgress(1);
        return;
      }

      paintProgress(0);

      let gsapBound = false;
      const cancelGsapWait = nptWhenGsapReady((gsap, ScrollTrigger) => {
        gsapBound = true;
        const state = { t: 0 };
        const tween = gsap.to(state, {
          t: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top 70%',
            end: 'top 45%',
            scrub: NPT_SCRUB,
            invalidateOnRefresh: true,
          },
          onUpdate: () => paintProgress(state.t),
        });

        const refreshSt = () => {
          ScrollTrigger.refresh();
          if (tween.scrollTrigger) {
            state.t = tween.scrollTrigger.progress;
            paintProgress(state.t);
          }
        };
        requestAnimationFrame(refreshSt);
        window.addEventListener('load', refreshSt, { once: true });
        const onOrient = () => refreshSt();
        window.addEventListener('orientationchange', onOrient);

        this._displayEyebrowCleanups.push(() => {
          window.removeEventListener('load', refreshSt);
          window.removeEventListener('orientationchange', onOrient);
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
          const clearPaint = (el) => {
            el.style.backgroundImage = '';
            el.style.backgroundRepeat = '';
            el.style.backgroundSize = '';
            el.style.webkitBackgroundClip = '';
            el.style.backgroundClip = '';
            el.style.color = '';
            el.style.webkitTextFillColor = '';
          };
          clearPaint(title);
          title.querySelectorAll('p, span, strong, em, b, i').forEach(clearPaint);
          title.style.willChange = '';
        });
      });

      const fallbackTimer = window.setTimeout(() => {
        if (!gsapBound) paintProgress(1);
      }, 4500);
      this._displayEyebrowCleanups.push(() => {
        window.clearTimeout(fallbackTimer);
        if (typeof cancelGsapWait === 'function') cancelGsapWait();
      });
    }

    /** 智能屏显：Tab 切换 + desk/文案滚动 scrub 与切换动画 */
    initDisplayTabs() {
      this._displayTabsCleanups = this._displayTabsCleanups || [];
      this._runCleanups(this._displayTabsCleanups);
      const cleanups = this._displayTabsCleanups;
      const reduced = nptPrefersReducedMotion();

      this.querySelectorAll('[data-npt-display]').forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        const tabs = Array.from(section.querySelectorAll('[data-npt-display-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-npt-display-panel]')).filter(
          (el) => el instanceof HTMLElement
        );
        if (!tabs.length || !panels.length) return;

        let current = 0;
        let switchToken = 0;
        let switchTl = null;
        let scrollTl = null;
        let gsapRef = null;
        /** 对齐卖点舞台：仅 160W 首轮滚入 scrub，切换后封印 */
        let enterSealed = false;
        const SCROLL_PANEL_INDEX = 0;
        const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

        const syncTabs = (index) => {
          const idx = String(index);
          tabs.forEach((tab) => {
            const on = tab.getAttribute('data-npt-display-tab') === idx;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            if (on) tab.removeAttribute('tabindex');
            else tab.setAttribute('tabindex', '-1');
          });
        };

        const showPanel = (index) => {
          panels.forEach((panel, i) => {
            const on = i === index;
            panel.classList.toggle('is-active', on);
            if (on) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          });
        };

        const killScroll = () => {
          if (!scrollTl) return;
          if (scrollTl.scrollTrigger) scrollTl.scrollTrigger.kill();
          scrollTl.kill();
          scrollTl = null;
        };

        const killSwitch = () => {
          if (!switchTl) return;
          switchTl.kill();
          switchTl = null;
        };

        const clearInline = (parts) => {
          if (!gsapRef) return;
          /* 共用文案不随 Tab 清样式，避免切换打断滚入 */
          const targets = [parts.desk, parts.product, parts.mo, ...parts.floats].filter(Boolean);
          gsapRef.set(targets, { clearProps: 'opacity,transform,y' });
        };

        const beatActive = (beat) => {
          const mo = window.matchMedia(MOBILE_MQ).matches;
          if (mo) return beat.kind === 'mo';
          return beat.kind !== 'mo';
        };

        const setPartsState = (parts, visible) => {
          if (!gsapRef) return;
          NPT_DISPLAY_ENTER_BEATS.forEach((beat) => {
            if (!beatActive(beat)) return;
            const el = nptDisplayResolveBeatEl(parts, beat);
            if (!el) return;
            const vars = visible ? nptDisplayBeatToVars(beat) : nptDisplayBeatFromVars(beat, 1);
            gsapRef.set(el, vars);
          });
        };

        const buildScrubEnter = (tl, parts) => {
          NPT_DISPLAY_ENTER_BEATS.forEach((beat) => {
            if (!beatActive(beat)) return;
            const el = nptDisplayResolveBeatEl(parts, beat);
            if (!el) return;
            const dur = beat.kind === 'product' || beat.kind === 'mo' ? 0.34 : 0.3;
            tl.fromTo(
              el,
              nptDisplayBeatFromVars(beat, 1),
              { ...nptDisplayBeatToVars(beat), duration: dur, ease: 'none', immediateRender: false },
              beat.at
            );
          });
        };

        /** 仅 PC 160W 滚入；手机端除眉标题外无动画 */
        const bindScroll = (panel, { reset } = {}) => {
          killScroll();
          if (reduced || !gsapRef || enterSealed || isMobile()) return;
          const parts = nptDisplayPanelParts(panel);
          if (!(parts.stage instanceof HTMLElement)) return;
          if (reset) setPartsState(parts, false);

          const triggerEl = parts.desk || parts.stage;

          scrollTl = gsapRef.timeline({
            defaults: { ease: 'none' },
            scrollTrigger: {
              trigger: triggerEl,
              start: 'top 20%',
              end: 'top top',
              scrub: NPT_SCRUB,
              invalidateOnRefresh: true,
            },
          });
          buildScrubEnter(scrollTl, parts);
        };

        /** Tab 切换：desk / mo 原地淡出，文案不动*/
        const playSwitchOut = (parts) => {
          const tl = gsapRef.timeline({ defaults: { ease: 'sine.in' } });
          if (parts.desk) tl.to(parts.desk, { opacity: 0, duration: 0.22 }, 0);
          if (parts.mo && isMobile()) tl.to(parts.mo, { opacity: 0, duration: 0.22 }, 0);
          return tl;
        };

        /** Tab 切换：desk / mo 原地淡入 */
        const playSwitchIn = (parts) => {
          const tl = gsapRef.timeline({ defaults: { ease: 'sine.out' } });
          if (parts.desk) tl.fromTo(parts.desk, { opacity: 0 }, { opacity: 1, duration: 0.4 }, 0);
          if (parts.mo && isMobile()) tl.fromTo(parts.mo, { opacity: 0 }, { opacity: 1, duration: 0.4 }, 0);
          return tl;
        };

        const activate = (index, { animate } = { animate: true }) => {
          const next = Number(index);
          if (!Number.isFinite(next) || next < 0 || next >= panels.length) return;
          if (next === current && animate) return;

          syncTabs(next);

          const skipMotion = reduced || !gsapRef || !animate;
          if (skipMotion) {
            killScroll();
            killSwitch();
            panels.forEach((panel) => clearInline(nptDisplayPanelParts(panel)));
            showPanel(next);
            if (current === SCROLL_PANEL_INDEX && next !== SCROLL_PANEL_INDEX) {
              enterSealed = true;
            }
            current = next;
            if (!reduced && gsapRef && !isMobile() && next === SCROLL_PANEL_INDEX && !enterSealed) {
              bindScroll(panels[SCROLL_PANEL_INDEX], { reset: true });
            }
            return;
          }

          const token = ++switchToken;
          const fromParts = nptDisplayPanelParts(panels[current]);
          const toPanel = panels[next];
          const toParts = nptDisplayPanelParts(toPanel);
          const leavingScrollPanel = current === SCROLL_PANEL_INDEX && next !== SCROLL_PANEL_INDEX;

          killScroll();
          killSwitch();
          if (leavingScrollPanel) enterSealed = true;

          switchTl = gsapRef.timeline({
            onComplete: () => {
              if (token !== switchToken) return;
              switchTl = null;
              current = next;
              if (next === SCROLL_PANEL_INDEX && !enterSealed) {
                bindScroll(panels[SCROLL_PANEL_INDEX], { reset: false });
                if (window.ScrollTrigger) {
                  try {
                    window.ScrollTrigger.refresh();
                  } catch (_) {}
                }
              } else {
                clearInline(nptDisplayPanelParts(panels[current]));
              }
            },
          });

          switchTl.add(playSwitchOut(fromParts));
          switchTl.add(() => {
            if (token !== switchToken) return;
            showPanel(next);
            /* 子元素就位，仅 desk/mo 做透明度淡入 */
            setPartsState(toParts, true);
            if (toParts.desk) gsapRef.set(toParts.desk, { opacity: 0 });
            if (toParts.mo && isMobile()) gsapRef.set(toParts.mo, { opacity: 0 });
          });
          switchTl.add(playSwitchIn(toParts));
        };

        const boot = (gsap) => {
          gsapRef = gsap;
          showPanel(0);
          syncTabs(0);
          current = 0;
          enterSealed = false;
          if (reduced || !gsapRef) return;
          /* 共用文案始终可见，清掉可能残留的滚入透明度 */
          const sharedCopy = section.querySelector('.ug-nexode-pro-template__display-copy');
          if (sharedCopy) {
            gsapRef.set(sharedCopy.querySelectorAll('.ug-nexode-pro-template__display-title, .ug-nexode-pro-template__display-desc'), {
              clearProps: 'opacity,transform,y',
            });
          }
          panels.forEach((panel, i) => {
            if (i === SCROLL_PANEL_INDEX) clearInline(nptDisplayPanelParts(panel));
            else setPartsState(nptDisplayPanelParts(panel), false);
          });
          if (isMobile()) return;
          bindScroll(panels[SCROLL_PANEL_INDEX], { reset: true });
          requestAnimationFrame(() => {
            if (window.ScrollTrigger) {
              try {
                window.ScrollTrigger.refresh();
              } catch (_) {}
            }
          });
        };

        if (reduced) {
          boot(null);
        } else {
          const cancelGsapWait = nptWhenGsapReady((gsap) => {
            boot(gsap);
          });
          cleanups.push(() => {
            if (typeof cancelGsapWait === 'function') cancelGsapWait();
          });
          // GSAP 未就绪时先露出首屏，避免空白
          showPanel(0);
          syncTabs(0);
        }

        tabs.forEach((tab) => {
          const onClick = () => activate(tab.getAttribute('data-npt-display-tab') || '0', { animate: true });
          tab.addEventListener('click', onClick);
          cleanups.push(() => tab.removeEventListener('click', onClick));
        });

        cleanups.push(() => {
          killSwitch();
          killScroll();
          panels.forEach((panel) => {
            if (gsapRef) clearInline(nptDisplayPanelParts(panel));
          });
        });
      });
    }

    /** 功能卡片：PC 手风琴（含展开内滑块）；手机轮播*/
    initFeatureCards() {
      this._featureCardsCleanups = this._featureCardsCleanups || [];
      this._runCleanups(this._featureCardsCleanups);
      const cleanups = this._featureCardsCleanups;
      const reduced = nptPrefersReducedMotion();

      this.querySelectorAll('[data-npt-features]').forEach((root) => {
        if (!(root instanceof HTMLElement)) return;

        const desk = root.querySelector('[data-npt-features-desk]');
        if (desk instanceof HTMLElement) {
          const cards = Array.from(desk.querySelectorAll('[data-npt-features-card]')).filter(
            (el) => el instanceof HTMLElement
          );

          /* 预热展开图，避免首次切换时解码空白 */
          cards.forEach((card) => {
            card.querySelectorAll('.ug-nexode-pro-template__features-img--open').forEach((node) => {
              if (!(node instanceof HTMLImageElement) || !node.src) return;
              if (node.complete && node.naturalWidth > 0) return;
              const warm = new Image();
              warm.decoding = 'async';
              warm.src = node.currentSrc || node.src;
            });
          });

          /** @type {Map<HTMLElement, { go: (n: number) => void, stop: () => void, start: () => void, reset: () => void }>} */
          const openSliders = new Map();
          cards.forEach((card) => {
            const slider = card.querySelector('[data-npt-features-open-slider]');
            if (!(slider instanceof HTMLElement)) return;
            const slides = Array.from(slider.querySelectorAll('[data-npt-features-open-slide]')).filter(
              (el) => el instanceof HTMLElement
            );
            const dots = Array.from(slider.querySelectorAll('[data-npt-features-open-dot]')).filter(
              (el) => el instanceof HTMLElement
            );
            if (slides.length < 2) return;

            let index = 0;
            let timer = 0;

            const sync = () => {
              slides.forEach((slide, i) => {
                slide.classList.toggle('is-active', i === index);
              });
              dots.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === index);
              });
            };

            const go = (/** @type {number} */ next) => {
              index = ((next % slides.length) + slides.length) % slides.length;
              sync();
            };

            const stop = () => {
              if (timer) {
                window.clearInterval(timer);
                timer = 0;
              }
            };

            const start = () => {
              stop();
              if (reduced) return;
              timer = window.setInterval(() => go(index + 1), NPT_FEATURES_OPEN_SLIDER_MS);
            };

            const reset = () => {
              stop();
              index = 0;
              sync();
            };

            dots.forEach((dot) => {
              const onDot = (ev) => {
                ev.stopPropagation();
                const n = Number(dot.getAttribute('data-npt-features-open-dot') || '0');
                go(n);
                if (card.classList.contains('is-open')) start();
              };
              dot.addEventListener('click', onDot);
              cleanups.push(() => dot.removeEventListener('click', onDot));
            });

            openSliders.set(card, { go, stop, start, reset });
            cleanups.push(() => {
              stop();
              openSliders.delete(card);
            });
            sync();
          });

          /** 只展开/切换，不收回全收起*/
          const setOpen = (/** @type {HTMLElement} */ target) => {
            if (target.classList.contains('is-open')) return;

            cards.forEach((card) => {
              const open = card === target;
              const wasOpen = card.classList.contains('is-open');
              card.classList.toggle('is-open', open);
              const btn = card.querySelector('[data-npt-features-toggle]');
              if (btn instanceof HTMLElement) btn.hidden = open;
              const ctrl = openSliders.get(card);
              if (!ctrl) return;
              if (open) ctrl.start();
              else if (wasOpen) ctrl.reset();
            });

            desk.classList.add('has-open');
          };

          cards.forEach((card) => {
            const onCardClick = (ev) => {
              /* 展开内圆点自行翻页，不触发换卡 */
              if (ev.target instanceof Element && ev.target.closest('[data-npt-features-open-dot]')) return;
              setOpen(card);
            };
            card.addEventListener('click', onCardClick);
            cleanups.push(() => card.removeEventListener('click', onCardClick));
          });
        }

        const mo = root.querySelector('[data-npt-features-mo]');
        if (!(mo instanceof HTMLElement)) return;

        const viewport = mo.querySelector('.ug-nexode-pro-template__features-mo-viewport');
        const track = mo.querySelector('[data-npt-features-track]');
        const slides = Array.from(mo.querySelectorAll('[data-npt-features-slide]')).filter(
          (el) => el instanceof HTMLElement
        );
        if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !slides.length) return;

        nptBindPercentCarousel({
          viewport,
          track,
          slides,
          prevBtn: mo.querySelector('[data-npt-features-prev]'),
          nextBtn: mo.querySelector('[data-npt-features-next]'),
          progress: mo.querySelector('[data-npt-features-progress]'),
          progressFillClass: 'ug-nexode-pro-template__features-mo-progress-fill',
          cleanups,
        });
      });
    }

    /** 旗舰单口：手机功能卡轮播 + 设备条无限滚动*/
    initFlagshipOutput() {
      this._flagshipCleanups = this._flagshipCleanups || [];
      this._runCleanups(this._flagshipCleanups);
      const cleanups = this._flagshipCleanups;
      const reduced = nptPrefersReducedMotion();

      this.querySelectorAll('[data-npt-flagship]').forEach((root) => {
        if (!(root instanceof HTMLElement)) return;

        const mo = root.querySelector('[data-npt-flagship-features]');
        if (mo instanceof HTMLElement) {
          const viewport = mo.querySelector('[data-npt-flagship-features-viewport]');
          const track = mo.querySelector('[data-npt-flagship-features-track]');
          const slides = Array.from(mo.querySelectorAll('[data-npt-flagship-features-slide]')).filter(
            (el) => el instanceof HTMLElement
          );
          if (viewport instanceof HTMLElement && track instanceof HTMLElement && slides.length) {
            nptBindPercentCarousel({
              viewport,
              track,
              slides,
              prevBtn: mo.querySelector('[data-npt-flagship-features-prev]'),
              nextBtn: mo.querySelector('[data-npt-flagship-features-next]'),
              progress: mo.querySelector('[data-npt-flagship-features-progress]'),
              progressFillClass: 'ug-nexode-pro-template__flagship-features-mo-progress-fill',
              cleanups,
            });
          }
        }

        /* 旗舰特性视频：进视口只播当前断点可见实例，离视口 pause + 卸 src */
        const flagshipVideos = Array.from(
          root.querySelectorAll('.ug-nexode-pro-template__flagship-feature-video')
        ).filter((v) => v instanceof HTMLVideoElement);
        flagshipVideos.forEach((video) => {
          try {
            video.removeAttribute('autoplay');
            video.loop = true;
            video.preload = 'metadata';
          } catch (_) {}
        });
        if (flagshipVideos.length) {
          const syncFlagshipVideos = (visible) => {
            const isMobile = window.matchMedia(MOBILE_MQ).matches;
            flagshipVideos.forEach((video) => {
              const inMo = !!video.closest('[data-npt-flagship-features]');
              const activeForBp = isMobile ? inMo : !inMo;
              if (visible && activeForBp) nptRestoreAndPlayInlineVideo(video);
              else nptPauseInlineVideo(video, true);
            });
          };
          cleanups.push(
            nptObserveInView(root, (visible) => syncFlagshipVideos(visible), { threshold: 0.12 })
          );
          const onFlagshipMq = () => {
            /* 断点切换时按当前是否在视口重同步 */
            const rect = root.getBoundingClientRect();
            const vh = window.innerHeight || 1;
            const visible = rect.bottom > 0 && rect.top < vh;
            syncFlagshipVideos(visible);
          };
          window.addEventListener('resize', onFlagshipMq, { passive: true });
          cleanups.push(() => window.removeEventListener('resize', onFlagshipMq));
        }

        const devices = root.querySelector('[data-npt-flagship-devices]');
        const devicesTrack = devices
          ? devices.querySelector('[data-npt-flagship-devices-track]')
          : null;
        if (!(devicesTrack instanceof HTMLElement)) return;

        const items = Array.from(devicesTrack.children);
        if (!items.length) return;

        if (reduced) return;

        /* reinit 时勿重复克隆，否则节点翻倍 */
        if (devicesTrack.dataset.nptMarqueeCloned !== '1') {
          items.forEach((item) => {
            devicesTrack.appendChild(item.cloneNode(true));
          });
          devicesTrack.dataset.nptMarqueeCloned = '1';
        }

        const speed = 28;
        let position = 0;
        let paused = false;
        let inView = false;
        let raf = 0;

        const onEnter = () => {
          paused = true;
        };
        const onLeave = () => {
          paused = false;
        };
        devicesTrack.addEventListener('mouseenter', onEnter);
        devicesTrack.addEventListener('mouseleave', onLeave);
        cleanups.push(() => {
          devicesTrack.removeEventListener('mouseenter', onEnter);
          devicesTrack.removeEventListener('mouseleave', onLeave);
        });

        const stopRaf = () => {
          if (raf) {
            window.cancelAnimationFrame(raf);
            raf = 0;
          }
        };

        const tick = () => {
          raf = 0;
          if (!inView) return;
          if (!paused) {
            position -= speed / 60;
            const first = devicesTrack.children[0];
            if (first instanceof HTMLElement) {
              const styles = window.getComputedStyle(devicesTrack);
              const gap = parseFloat(styles.columnGap || styles.gap) || 0;
              const step = first.getBoundingClientRect().width + gap;
              if (step > 0 && Math.abs(position) >= step) {
                devicesTrack.appendChild(first);
                position += step;
              }
            }
            devicesTrack.style.transform = `translate3d(${position}px,0,0)`;
          }
          raf = window.requestAnimationFrame(tick);
        };

        const startRaf = () => {
          if (!raf) raf = window.requestAnimationFrame(tick);
        };

        const observeEl = devices instanceof HTMLElement ? devices : devicesTrack;
        cleanups.push(
          nptObserveInView(observeEl, (visible) => {
            inView = visible;
            if (visible) startRaf();
            else stopRaf();
          })
        );
        cleanups.push(stopRaf);
      });
    }

    /** 安全耐用：手机轮播*/
    initSafeDurable() {
      this._safeDurableCleanups = this._safeDurableCleanups || [];
      this._runCleanups(this._safeDurableCleanups);
      const cleanups = this._safeDurableCleanups;

      this.querySelectorAll('[data-npt-safe]').forEach((root) => {
        if (!(root instanceof HTMLElement)) return;
        const mo = root.querySelector('[data-npt-safe-mo]');
        if (!(mo instanceof HTMLElement)) return;

        const viewport = mo.querySelector('.ug-nexode-pro-template__safe-mo-viewport');
        const track = mo.querySelector('[data-npt-safe-track]');
        const slides = Array.from(mo.querySelectorAll('[data-npt-safe-slide]')).filter(
          (el) => el instanceof HTMLElement
        );
        if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !slides.length) return;

        nptBindPercentCarousel({
          viewport,
          track,
          slides,
          prevBtn: mo.querySelector('[data-npt-safe-prev]'),
          nextBtn: mo.querySelector('[data-npt-safe-next]'),
          progress: mo.querySelector('[data-npt-safe-progress]'),
          progressFillClass: 'ug-nexode-pro-template__safe-mo-progress-fill',
          cleanups,
        });
      });
    }

    /** 安全耐用标题：浅 → 深滚动渐变 */
    initSafeTitle() {
      this._safeTitleCleanups = this._safeTitleCleanups || [];
      this._runCleanups(this._safeTitleCleanups);

      const section = this.querySelector('[data-npt-safe]');
      const title = section
        ? section.querySelector('.ug-nexode-pro-template__safe-title')
        : null;
      if (!(section instanceof HTMLElement) || !(title instanceof HTMLElement)) return;

      const GRAD_COLORS = ['#FFF', '#E6D2BD', '#3E6B94', '#092D43'];
      const STOP_START = [0, 100, 200, 300];
      const STOP_END = [-381.7, -192.63, -6.03, 100];

      const paintStops = (stops) => {
        const bg = `linear-gradient(0deg, ${GRAD_COLORS[0]} ${stops[0]}%, ${GRAD_COLORS[1]} ${stops[1]}%, ${GRAD_COLORS[2]} ${stops[2]}%, ${GRAD_COLORS[3]} ${stops[3]}%)`;
        title.style.backgroundImage = bg;
        title.style.backgroundRepeat = 'no-repeat';
        title.style.backgroundSize = '100% 100%';
        title.style.webkitBackgroundClip = 'text';
        title.style.backgroundClip = 'text';
        title.style.color = 'transparent';
        title.style.webkitTextFillColor = 'transparent';
      };

      const paintEnd = () => paintStops(STOP_END);

      if (nptPrefersReducedMotion()) {
        paintEnd();
        return;
      }

      paintStops(STOP_START);

      let gsapBound = false;
      const cancelGsapWait = nptWhenGsapReady((gsap, ScrollTrigger) => {
        gsapBound = true;
        const state = {
          s0: STOP_START[0],
          s1: STOP_START[1],
          s2: STOP_START[2],
          s3: STOP_START[3],
        };
        const tween = gsap.to(state, {
          s0: STOP_END[0],
          s1: STOP_END[1],
          s2: STOP_END[2],
          s3: STOP_END[3],
          ease: 'none',
          scrollTrigger: {
            trigger: title,
            start: 'top 70%',
            end: 'top 50%',
            scrub: NPT_SCRUB,
            invalidateOnRefresh: true,
          },
          onUpdate: () => {
            paintStops([state.s0, state.s1, state.s2, state.s3]);
          },
        });

        const refreshSt = () => {
          ScrollTrigger.refresh();
          if (tween.scrollTrigger) {
            const p = tween.scrollTrigger.progress;
            state.s0 = STOP_START[0] + (STOP_END[0] - STOP_START[0]) * p;
            state.s1 = STOP_START[1] + (STOP_END[1] - STOP_START[1]) * p;
            state.s2 = STOP_START[2] + (STOP_END[2] - STOP_START[2]) * p;
            state.s3 = STOP_START[3] + (STOP_END[3] - STOP_START[3]) * p;
            paintStops([state.s0, state.s1, state.s2, state.s3]);
          }
        };
        requestAnimationFrame(refreshSt);
        window.addEventListener('load', refreshSt, { once: true });
        const onOrient = () => refreshSt();
        window.addEventListener('orientationchange', onOrient);

        this._safeTitleCleanups.push(() => {
          window.removeEventListener('load', refreshSt);
          window.removeEventListener('orientationchange', onOrient);
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
          title.style.backgroundImage = '';
          title.style.backgroundRepeat = '';
          title.style.backgroundSize = '';
          title.style.webkitBackgroundClip = '';
          title.style.backgroundClip = '';
          title.style.color = '';
          title.style.webkitTextFillColor = '';
          title.style.willChange = '';
        });
      });

      const fallbackTimer = window.setTimeout(() => {
        if (!gsapBound) paintEnd();
      }, 4500);
      this._safeTitleCleanups.push(() => {
        window.clearTimeout(fallbackTimer);
        if (typeof cancelGsapWait === 'function') cancelGsapWait();
      });
    }

    /**
     * 场景轮播：首尾克隆无缝循环 + 拖拽 + 自动播放；PC dots / 手机进度条
     * 逻辑对齐 nexode-air-template initNexodeTravelScene
     */
    initScenes() {
      this._scenesCleanups = this._scenesCleanups || [];
      this._runCleanups(this._scenesCleanups);
      const cleanups = this._scenesCleanups;
      const reduced = nptPrefersReducedMotion();

      this.querySelectorAll('[data-npt-scenes]').forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        const viewport = section.querySelector('[data-npt-scenes-viewport]');
        const track = section.querySelector('[data-npt-scenes-track]');
        const navPrevList = Array.from(section.querySelectorAll('[data-npt-scenes-prev]'));
        const navNextList = Array.from(section.querySelectorAll('[data-npt-scenes-next]'));
        const dots = Array.from(section.querySelectorAll('[data-npt-scenes-dot]'));
        const progressFill = section.querySelector('[data-npt-scenes-progress-fill]');
        const cards = Array.from(section.querySelectorAll('[data-npt-scenes-card]')).filter(
          (card) => card instanceof HTMLElement
        );
        if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement) || !cards.length) {
          return;
        }

        const realCount = cards.length;
        let autoTimer = 0;

        const slides = Array.from(track.children).filter((slide) => slide instanceof HTMLElement);
        let currentSlide = 0;
        let activeIndex = 0;
        let isDragging = false;
        let dragPointerId = null;
        let dragStartX = 0;
        let dragBaseX = 0;
        let dragDeltaX = 0;

        const getRealIndexBySlide = (slideIndex) => Math.max(0, Math.min(slideIndex, realCount - 1));

        const getTargetTranslateX = (slideIndex) => {
          const activeCard = slides[slideIndex];
          if (!(activeCard instanceof HTMLElement) || viewport.clientWidth <= 0) return 0;
          const rawTarget = activeCard.offsetLeft + activeCard.offsetWidth / 2 - viewport.clientWidth / 2;
          return -rawTarget;
        };

        const getCurrentTranslateX = () => {
          const tf = window.getComputedStyle(track).transform;
          if (!tf || tf === 'none') return getTargetTranslateX(currentSlide);
          const m2d = tf.match(/^matrix\((.+)\)$/);
          if (m2d && m2d[1]) {
            const parts = m2d[1].split(',').map((s) => Number.parseFloat(s.trim()));
            return Number.isFinite(parts[4]) ? parts[4] : getTargetTranslateX(currentSlide);
          }
          const m3d = tf.match(/^matrix3d\((.+)\)$/);
          if (m3d && m3d[1]) {
            const parts = m3d[1].split(',').map((s) => Number.parseFloat(s.trim()));
            return Number.isFinite(parts[12]) ? parts[12] : getTargetTranslateX(currentSlide);
          }
          return getTargetTranslateX(currentSlide);
        };

        const updateUiBySlide = () => {
          activeIndex = getRealIndexBySlide(currentSlide);
          dots.forEach((btn, i) => {
            if (!(btn instanceof HTMLElement)) return;
            const on = i === activeIndex;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          cards.forEach((card, i) => {
            card.classList.toggle('is-active', i === activeIndex);
          });
          if (progressFill instanceof HTMLElement && realCount > 0) {
            const pct = ((activeIndex + 1) / realCount) * 100;
            progressFill.style.width = `${pct}%`;
          }
          /* 到首尾停住并禁用箭头 */
          const atStart = activeIndex <= 0;
          const atEnd = activeIndex >= realCount - 1;
          navPrevList.forEach((btn) => {
            if (!(btn instanceof HTMLElement)) return;
            btn.classList.toggle('is-disabled', atStart);
            btn.disabled = atStart;
          });
          navNextList.forEach((btn) => {
            if (!(btn instanceof HTMLElement)) return;
            btn.classList.toggle('is-disabled', atEnd);
            btn.disabled = atEnd;
          });
        };

        const updateTrackTranslate = (immediate, slideIndex = currentSlide) => {
          const targetX = getTargetTranslateX(slideIndex);
          if (immediate) {
            track.style.transition = 'none';
            track.style.transform = `translate3d(${targetX}px, 0, 0)`;
            window.requestAnimationFrame(() => {
              track.style.removeProperty('transition');
            });
            return;
          }
          track.style.transform = `translate3d(${targetX}px, 0, 0)`;
        };

        const activateByRealIndex = (idx, immediate) => {
          const safeIdx = Math.max(0, Math.min(idx, realCount - 1));
          currentSlide = safeIdx;
          updateUiBySlide();
          updateTrackTranslate(immediate, currentSlide);
        };

        const shiftSlide = (delta) => {
          currentSlide = Math.max(0, Math.min(currentSlide + delta, realCount - 1));
          updateUiBySlide();
          updateTrackTranslate(false, currentSlide);
        };

        const clearAutoPlay = () => {
          if (autoTimer) {
            window.clearInterval(autoTimer);
            autoTimer = 0;
          }
        };

        let inView = false;
        const startAutoPlay = () => {
          clearAutoPlay();
          if (!inView || realCount <= 1 || reduced) return;
          autoTimer = window.setInterval(() => {
            if (activeIndex >= realCount - 1) {
              clearAutoPlay();
              return;
            }
            shiftSlide(1);
          }, NPT_CAROUSEL_AUTOPLAY_MS);
        };

        const restartAutoPlay = () => {
          startAutoPlay();
        };

        dots.forEach((btn, idx) => {
          const onClick = () => {
            activateByRealIndex(idx, false);
            restartAutoPlay();
          };
          btn.addEventListener('click', onClick);
          cleanups.push(() => btn.removeEventListener('click', onClick));
        });

        const bindNavBtn = (btn, delta) => {
          if (!(btn instanceof HTMLElement) || realCount <= 1) return;
          const onNavClick = (ev) => {
            if (ev instanceof MouseEvent && ev.button !== 0) return;
            shiftSlide(delta);
            restartAutoPlay();
          };
          btn.addEventListener('click', onNavClick);
          cleanups.push(() => btn.removeEventListener('click', onNavClick));
        };
        navPrevList.forEach((btn) => bindNavBtn(btn, -1));
        navNextList.forEach((btn) => bindNavBtn(btn, 1));

        const onResize = () => updateTrackTranslate(true);
        window.addEventListener('resize', onResize, { passive: true });
        cleanups.push(() => window.removeEventListener('resize', onResize));

        const onPointerDown = (ev) => {
          if (!(ev instanceof PointerEvent) || realCount <= 1) return;
          const targetEl = ev.target instanceof Element ? ev.target : null;
          if (targetEl && targetEl.closest('.ug-nexode-air-template__charge-promo-buy, a, button')) {
            return;
          }
          if (ev.pointerType === 'mouse' && ev.button !== 0) return;
          isDragging = true;
          dragPointerId = ev.pointerId;
          dragStartX = ev.clientX;
          dragDeltaX = 0;
          dragBaseX = getCurrentTranslateX();
          clearAutoPlay();
          track.style.transition = 'none';
          section.classList.add('is-scenes-dragging');
          try {
            viewport.setPointerCapture(ev.pointerId);
          } catch (_) {}
          ev.preventDefault();
        };

        const onPointerMove = (ev) => {
          if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) return;
          dragDeltaX = ev.clientX - dragStartX;
          track.style.transform = `translate3d(${dragBaseX + dragDeltaX}px, 0, 0)`;
        };

        const finishDrag = (ev) => {
          if (!(ev instanceof PointerEvent) || !isDragging || dragPointerId !== ev.pointerId) return;
          isDragging = false;
          dragPointerId = null;
          section.classList.remove('is-scenes-dragging');
          try {
            viewport.releasePointerCapture(ev.pointerId);
          } catch (_) {}
          track.style.removeProperty('transition');
          const threshold = Math.max(40, viewport.clientWidth * 0.08);
          if (Math.abs(dragDeltaX) >= threshold) {
            /* 阿语下一张在左侧，向右拖才是前进 */
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl';
            const forward = isRtl ? dragDeltaX > 0 : dragDeltaX < 0;
            shiftSlide(forward ? 1 : -1);
          } else {
            updateTrackTranslate(false, currentSlide);
          }
          dragDeltaX = 0;
          restartAutoPlay();
        };

        viewport.addEventListener('pointerdown', onPointerDown);
        viewport.addEventListener('pointermove', onPointerMove);
        viewport.addEventListener('pointerup', finishDrag);
        viewport.addEventListener('pointercancel', finishDrag);
        cleanups.push(() => viewport.removeEventListener('pointerdown', onPointerDown));
        cleanups.push(() => viewport.removeEventListener('pointermove', onPointerMove));
        cleanups.push(() => viewport.removeEventListener('pointerup', finishDrag));
        cleanups.push(() => viewport.removeEventListener('pointercancel', finishDrag));

        const onMouseEnter = () => clearAutoPlay();
        const onMouseLeave = () => startAutoPlay();
        section.addEventListener('mouseenter', onMouseEnter);
        section.addEventListener('mouseleave', onMouseLeave);
        cleanups.push(() => section.removeEventListener('mouseenter', onMouseEnter));
        cleanups.push(() => section.removeEventListener('mouseleave', onMouseLeave));

        const onVisibilityChange = () => {
          if (document.hidden) clearAutoPlay();
          else startAutoPlay();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        cleanups.push(() => document.removeEventListener('visibilitychange', onVisibilityChange));

        activateByRealIndex(0, true);
        cleanups.push(
          nptObserveInView(section, (visible) => {
            inView = visible;
            if (visible) startAutoPlay();
            else clearAutoPlay();
          })
        );
        cleanups.push(() => clearAutoPlay());
      });
    }

    /**
     * 系列亮相 + 一图懂：pin 内层 + NPT_SCRUB 缓跟
     * Cut1→ 亮相 → Cut5 窗口缩入中槽 + 一图懂 1536→280 → Cut6 窗内 UI/小标题
     */
    initSeriesGlance() {
      this._seriesRevealCleanups = this._seriesRevealCleanups || [];
      this._runCleanups(this._seriesRevealCleanups);
      const cleanups = this._seriesRevealCleanups;

      const section = this.querySelector('[data-npt-series-glance]');
      const pin = section ? section.querySelector('[data-npt-series-glance-pin]') : null;
      const stage = section ? section.querySelector('[data-npt-series-glance-stage]') : null;
      const glance = section ? section.querySelector('[data-npt-glance]') : null;
      const glanceInner = section ? section.querySelector('[data-npt-glance-inner]') : null;
      const slot = section ? section.querySelector('[data-npt-glance-slot]') : null;
      if (!(section instanceof HTMLElement) || !(pin instanceof HTMLElement) || !(stage instanceof HTMLElement)) {
        return;
      }

      const bg = stage.querySelector('[data-npt-reveal-bg]');
      const wave = stage.querySelector('[data-npt-reveal-wave]');
      const waveScaler =
        wave instanceof HTMLElement
          ? wave.querySelector('[data-npt-reveal-wave-scaler]')
          : null;
      const question = stage.querySelector('[data-npt-reveal-question]');
      const series = stage.querySelector('[data-npt-reveal-series]');
      const product = stage.querySelector('[data-npt-reveal-product]');
      const productLit = stage.querySelector('[data-npt-reveal-product-lit]');
      const copy = stage.querySelector('[data-npt-reveal-copy]');
      const windowUi = stage.querySelector('[data-npt-reveal-window-ui]');
      const windowTitle = stage.querySelector('[data-npt-reveal-window-title]');
      const nav = this.querySelector('[data-npt-kv-nav]');
      const reduced = nptPrefersReducedMotion();
      const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

      /* 一图懂「更多」：与 kv-nav 同套页内锚点滚动 */
      const onGlanceAnchorClick = (ev) => {
        const link = ev.currentTarget;
        if (!(link instanceof HTMLAnchorElement)) return;
        const target = nptResolveScrollTarget(link, this);
        if (!target) return;
        ev.preventDefault();
        nptJumpToPageAnchor(target, nav, reduced);
      };
      Array.from(section.querySelectorAll('[data-npt-glance-anchor]')).forEach((el) => {
        el.addEventListener('click', onGlanceAnchorClick);
        cleanups.push(() => el.removeEventListener('click', onGlanceAnchorClick));
      });

      /* TVC：对齐 Air TVC → YouTube 弹窗 */
      const videoModal = section.querySelector('[data-npt-glance-video-modal]');
      const videoIframe = section.querySelector('[data-npt-glance-video-iframe]');
      const videoTrigger = section.querySelector('[data-npt-glance-video-trigger]');
      if (
        videoModal instanceof HTMLElement &&
        videoIframe instanceof HTMLIFrameElement &&
        videoTrigger instanceof HTMLElement
      ) {
        const openVideoModal = () => {
          const embed = nptNormalizeYoutubeEmbed(
            videoTrigger.getAttribute('data-npt-glance-video-url') || ''
          );
          if (!embed) return;
          videoIframe.src = embed;
          videoModal.removeAttribute('hidden');
          videoModal.setAttribute('aria-hidden', 'false');
        };
        const closeVideoModal = () => {
          videoModal.setAttribute('hidden', '');
          videoModal.setAttribute('aria-hidden', 'true');
          videoIframe.src = '';
        };
        const onVideoTrigger = (e) => {
          e.preventDefault();
          openVideoModal();
        };
        videoTrigger.addEventListener('click', onVideoTrigger);
        cleanups.push(() => videoTrigger.removeEventListener('click', onVideoTrigger));
        Array.from(section.querySelectorAll('[data-npt-glance-video-close]')).forEach((btn) => {
          const onClose = (e) => {
            e.preventDefault();
            closeVideoModal();
          };
          btn.addEventListener('click', onClose);
          cleanups.push(() => btn.removeEventListener('click', onClose));
        });
        const onEsc = (e) => {
          if (!(e instanceof KeyboardEvent) || e.key !== 'Escape') return;
          if (videoModal.hasAttribute('hidden')) return;
          closeVideoModal();
        };
        window.addEventListener('keydown', onEsc);
        cleanups.push(() => {
          window.removeEventListener('keydown', onEsc);
          closeVideoModal();
        });
      }

      const measureSlot = () => {
        if (!(slot instanceof HTMLElement)) {
          return isMobile()
            ? /* 顶垫 20 + 顶行 136 + 间距 8 → 槽顶 164 */
              { left: 20, top: 164, width: Math.min(335, pin.clientWidth - 40), height: 136, radius: 8 }
            : {
                left: (pin.clientWidth - 632) / 2,
                top: (pin.clientHeight - 316) / 2,
                width: 632,
                height: 316,
                radius: 12,
              };
        }
        const pinBox = pin.getBoundingClientRect();
        const slotBox = slot.getBoundingClientRect();
        return {
          left: slotBox.left - pinBox.left,
          top: slotBox.top - pinBox.top,
          width: slotBox.width,
          height: slotBox.height,
          radius: isMobile() ? 8 : 12,
        };
      };

      /** 按终态 scale=1 量槽位，避免放大态导致归位偏大盖住邻卡 */
      const prepSlot = (gsapApi) => {
        if (!glance) return measureSlot();
        const prevOp = glance.style.opacity;
        const prevVis = glance.style.visibility;
        glance.style.opacity = '0.001';
        glance.style.visibility = 'visible';
        let savedScale = 1;
        if (glanceInner instanceof HTMLElement && gsapApi) {
          savedScale = Number(gsapApi.getProperty(glanceInner, 'scale')) || 1;
          gsapApi.set(glanceInner, { scale: 1, transformOrigin: '50% 50%' });
        }
        const t = measureSlot();
        glance.style.opacity = prevOp;
        glance.style.visibility = prevVis;
        if (glanceInner instanceof HTMLElement && gsapApi) {
          gsapApi.set(glanceInner, { scale: savedScale, transformOrigin: '50% 50%' });
        }
        return t;
      };

      const paintFinal = () => {
        section.classList.add('is-reveal-final', 'is-glance-final', 'is-glance-docked');
        if (glance) {
          glance.style.opacity = '1';
          glance.style.pointerEvents = 'auto';
          glance.removeAttribute('aria-hidden');
          if (glanceInner) glanceInner.style.transform = 'none';
        }
        const t = measureSlot();
        stage.style.left = `${t.left}px`;
        stage.style.top = `${t.top}px`;
        stage.style.bottom = 'auto';
        stage.style.width = `${t.width}px`;
        stage.style.height = `${t.height}px`;
        stage.style.borderRadius = `${t.radius}px`;
        if (this._nptPlayGlanceLoopVideo) this._nptPlayGlanceLoopVideo();
      };

      if (reduced) {
        paintFinal();
        return;
      }

      const productRise = () => {
        if (product instanceof HTMLElement && product.offsetHeight > 0) return product.offsetHeight;
        /* 手机稿产品高 438（MO 素材 295×438） */
        return isMobile() ? 438 : 592;
      };
      const questionLitScale = () => (isMobile() ? 28 / 32 : 64 / 72);
      const questionExitScale = () => (isMobile() ? 24 / 32 : 24 / 72);
      const seriesFromScale = () => (isMobile() ? 836 / 356 : 3);
      const productEndSize = () =>
        isMobile() ? { width: 84, height: Math.round((84 * 592) / 520) } : { width: 180, height: 206 };
      /* 仅 PC 同比例放大再缩回，Cut5 手感一致 */
      const GLANCE_SCALE0 = 1536 / 1280;

      let gsapBound = false;
      const cancelGsapWait = nptWhenGsapReady((gsap) => {
        if (!this.isConnected) return;
        gsapBound = true;

        const titleEl = series ? series.querySelector('.ug-nexode-pro-template__reveal-title') : null;
        const WAVE_SCALE_MID = 898 / 1920;
        const mo = isMobile();
        const seriesScale0 = seriesFromScale();
        const titleGlow = mo
          ? 'drop-shadow(0 0 2px rgba(255,255,255,0.8)) drop-shadow(0 0 10px rgba(211,244,253,0.5)) drop-shadow(0 0 36px rgba(211,244,253,0.3))'
          : 'drop-shadow(0 0 6px rgba(255,255,255,0.8)) drop-shadow(0 0 22px rgba(211,244,253,0.5)) drop-shadow(0 0 82px rgba(211,244,253,0.3))';

        if (bg) gsap.set(bg, { opacity: 0.55 });
        /* 外壳走 GSAP；scaler 做 opacity + scale（手机终态放大到 2 倍） */
        const waveScale0 = mo ? 0.55 : WAVE_SCALE_MID;
        const waveScale1 = mo ? 2 : 1;
        if (waveScaler) {
          gsap.set(waveScaler, {
            opacity: 0,
            scale: waveScale0,
            transformOrigin: '50% 50%',
          });
        }
        if (question) gsap.set(question, { opacity: 0.1, scale: 1, y: 0 });
        /* 从上往下：大尺寸自上入场，边缩小边回落到定位 */
        if (series) {
          gsap.set(series, {
            opacity: 0,
            scale: seriesScale0,
            y: mo ? -96 : -180,
            transformOrigin: '50% 50%',
          });
        }
        if (titleEl) gsap.set(titleEl, { filter: 'none' });
        if (product) gsap.set(product, { opacity: 0, y: productRise() });
        if (productLit) gsap.set(productLit, { opacity: 0 });
        if (copy) gsap.set(copy, { opacity: 0, y: 20 });
        if (windowUi) gsap.set(windowUi, { opacity: 0, y: 60 });
        if (windowTitle) gsap.set(windowTitle, { opacity: 0 });
        if (glance) gsap.set(glance, { opacity: 0 });
        if (glanceInner) gsap.set(glanceInner, { scale: GLANCE_SCALE0, transformOrigin: '50% 50%' });
        /* 舞台铺满 pin，背景全屏；Cut5 再缩入槽 */
        gsap.set(stage, {
          left: 0,
          top: 0,
          bottom: 'auto',
          width: '100%',
          height: '100%',
          borderRadius: 0,
        });
        gsap.set(section, { backgroundColor: '#01040c' });
        gsap.set(pin, { backgroundColor: '#01040c', overflow: 'visible' });
        section.classList.remove('is-glance-docked', 'is-reveal-final', 'is-glance-final');

        let slotTarget = prepSlot(gsap);

        const tl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: section,
            /* pin 内层满屏节点，减少 section 外壳亚像素顶缝 */
            pin: pin,
            start: 'top top',
            end: '+=360%',
            pinSpacing: true,
            scrub: NPT_SCRUB,
            invalidateOnRefresh: true,
            onRefresh: () => {
              slotTarget = prepSlot(gsap);
              if (pin instanceof HTMLElement && !section.classList.contains('is-glance-docked')) {
                pin.style.overflow = 'visible';
              }
            },
            onUpdate: (self) => {
              const docked = self.progress >= 0.48;
              section.classList.toggle('is-glance-docked', docked);
              if (pin instanceof HTMLElement) {
                pin.style.overflow = docked ? 'hidden' : 'visible';
              }
              if (glance) {
                if (docked) glance.removeAttribute('aria-hidden');
                else glance.setAttribute('aria-hidden', 'true');
              }
              if (docked) this._nptPlayGlanceLoopVideo && this._nptPlayGlanceLoopVideo();
            },
          },
        });

        if (bg) tl.to(bg, { opacity: 1, duration: 0.1 }, 0);
        if (question) tl.to(question, { opacity: 1, scale: questionLitScale(), duration: 0.1 }, 0);
        if (question) tl.to(question, { opacity: 0, scale: questionExitScale(), duration: 0.08 }, 0.12);
        if (series) tl.to(series, { opacity: 1, scale: 1, y: 0, duration: 0.14 }, 0.15);
        if (product) tl.to(product, { opacity: 1, y: 0, duration: 0.12 }, 0.16);
        if (waveScaler) {
          tl.to(waveScaler, { opacity: 1, scale: waveScale0, duration: 0.07 }, 0.22);
          tl.to(waveScaler, { scale: waveScale1, duration: 0.12 }, 0.28);
        }
        if (titleEl) tl.to(titleEl, { filter: titleGlow, duration: 0.1 }, 0.3);
        if (productLit) tl.to(productLit, { opacity: 1, duration: 0.08 }, 0.3);
        if (copy) {
          tl.to(copy, { opacity: 1, y: 0, duration: 0.08 }, 0.32);
        }
        tl.to({}, { duration: 0.06 }, 0.4);

        const CUT5 = 0.48;
        const endSize = productEndSize();

        /* Cut5 起点重测槽位，避免首屏未布局完导致归位飞入 */
        tl.call(() => {
          slotTarget = prepSlot(gsap);
        }, null, CUT5);

        if (glance) tl.to(glance, { opacity: 1, duration: 0.18 }, CUT5);
        if (glanceInner) tl.to(glanceInner, { scale: 1, duration: 0.22 }, CUT5);
        tl.to(section, { backgroundColor: '#ffffff', duration: 0.18 }, CUT5);
        tl.to(pin, { backgroundColor: '#ffffff', duration: 0.18 }, CUT5);
        tl.to(
          stage,
          {
            left: () => slotTarget.left,
            top: () => slotTarget.top,
            bottom: 'auto',
            width: () => slotTarget.width,
            height: () => slotTarget.height,
            borderRadius: () => slotTarget.radius,
            duration: 0.26,
          },
          CUT5
        );
        if (series) tl.to(series, { opacity: 0, y: -80, duration: 0.16 }, CUT5);
        if (copy) tl.to(copy, { opacity: 0, y: -40, duration: 0.14 }, CUT5 + 0.02);
        if (waveScaler) tl.to(waveScaler, { opacity: 0, duration: 0.12 }, CUT5);
        if (product) {
          tl.to(
            product,
            { width: endSize.width, height: endSize.height, maxWidth: endSize.width, duration: 0.24 },
            CUT5
          );
        }

        const CUT6 = 0.78;
        if (windowUi) tl.to(windowUi, { opacity: 1, y: 0, duration: 0.14 }, CUT6);
        if (windowTitle) tl.to(windowTitle, { opacity: 1, duration: 0.12 }, CUT6 + 0.04);
        tl.to({}, { duration: 0.08 }, 0.92);

        cleanups.push(() => {
          if (tl.scrollTrigger) tl.scrollTrigger.kill();
          tl.kill();
          gsap.set(
            [
              bg,
              wave,
              waveScaler,
              question,
              series,
              product,
              productLit,
              copy,
              windowUi,
              windowTitle,
              glance,
              glanceInner,
              stage,
              section,
              pin,
            ].filter(Boolean),
            { clearProps: 'all' }
          );
          if (titleEl) gsap.set(titleEl, { clearProps: 'filter' });
          section.classList.remove(
            'is-reveal-final',
            'is-glance-final',
            'is-glance-docked'
          );
        });
      });

      cleanups.push(() => {
        cancelGsapWait();
        if (!gsapBound) {
          section.classList.remove(
            'is-reveal-final',
            'is-glance-final',
            'is-glance-docked'
          );
        }
      });

      /* GSAP 未就绪时回落终态，避免一直停在暗态 */
      const fallbackTimer = window.setTimeout(() => {
        if (!gsapBound) paintFinal();
      }, 4500);
      cleanups.push(() => {
        window.clearTimeout(fallbackTimer);
      });
    }

    /**
     * Inside 标题：滚动 scrub 垂直渐变由浅至深
     * top 70% → top 50% 深色终态；回滚可反向循环
     */
    initInsideTitle() {
      this._insideTitleCleanups = this._insideTitleCleanups || [];
      this._runCleanups(this._insideTitleCleanups);

      const section = this.querySelector('[data-npt-inside-power]');
      const title = section
        ? section.querySelector('.ug-nexode-pro-template__inside-title')
        : null;
      if (!(section instanceof HTMLElement) || !(title instanceof HTMLElement)) return;

      const GRAD_COLORS = ['#FFF', '#E6D2BD', '#3E6B94', '#092D43'];
      const STOP_START = [0, 100, 200, 300];
      const STOP_END = [-381.7, -192.63, -6.03, 100];

      /* 改 backgroundImage 后需重设 clip；富文本子节点一并刷，避免 WebKit 丢渐变 */
      const paintStops = (stops) => {
        const bg = `linear-gradient(0deg, ${GRAD_COLORS[0]} ${stops[0]}%, ${GRAD_COLORS[1]} ${stops[1]}%, ${GRAD_COLORS[2]} ${stops[2]}%, ${GRAD_COLORS[3]} ${stops[3]}%)`;
        const apply = (el) => {
          el.style.backgroundImage = bg;
          el.style.backgroundRepeat = 'no-repeat';
          el.style.backgroundSize = '100% 100%';
          el.style.webkitBackgroundClip = 'text';
          el.style.backgroundClip = 'text';
          el.style.color = 'transparent';
          el.style.webkitTextFillColor = 'transparent';
        };
        apply(title);
        title.querySelectorAll('p, span, strong, em, b, i').forEach(apply);
      };

      const paintEnd = () => paintStops(STOP_END);

      if (nptPrefersReducedMotion()) {
        paintEnd();
        return;
      }

      paintStops(STOP_START);

      let gsapBound = false;
      const cancelGsapWait = nptWhenGsapReady((gsap, ScrollTrigger) => {
        gsapBound = true;
        const state = {
          s0: STOP_START[0],
          s1: STOP_START[1],
          s2: STOP_START[2],
          s3: STOP_START[3],
        };
        const tween = gsap.to(state, {
          s0: STOP_END[0],
          s1: STOP_END[1],
          s2: STOP_END[2],
          s3: STOP_END[3],
          ease: 'none',
          scrollTrigger: {
            trigger: title,
            start: 'top 70%',
            end: 'top 50%',
            scrub: NPT_SCRUB,
            invalidateOnRefresh: true,
          },
          onUpdate: () => {
            paintStops([state.s0, state.s1, state.s2, state.s3]);
          },
        });

        /* 初始化与地址栏伸缩后校准进度（手机端易丢失） */
        const refreshSt = () => {
          ScrollTrigger.refresh();
          if (tween.scrollTrigger) {
            const p = tween.scrollTrigger.progress;
            state.s0 = STOP_START[0] + (STOP_END[0] - STOP_START[0]) * p;
            state.s1 = STOP_START[1] + (STOP_END[1] - STOP_START[1]) * p;
            state.s2 = STOP_START[2] + (STOP_END[2] - STOP_START[2]) * p;
            state.s3 = STOP_START[3] + (STOP_END[3] - STOP_START[3]) * p;
            paintStops([state.s0, state.s1, state.s2, state.s3]);
          }
        };
        requestAnimationFrame(refreshSt);
        window.addEventListener('load', refreshSt, { once: true });
        const onOrient = () => refreshSt();
        window.addEventListener('orientationchange', onOrient);

        this._insideTitleCleanups.push(() => {
          window.removeEventListener('load', refreshSt);
          window.removeEventListener('orientationchange', onOrient);
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
          const clearPaint = (el) => {
            el.style.backgroundImage = '';
            el.style.backgroundRepeat = '';
            el.style.backgroundSize = '';
            el.style.webkitBackgroundClip = '';
            el.style.backgroundClip = '';
            el.style.color = '';
            el.style.webkitTextFillColor = '';
          };
          clearPaint(title);
          title.querySelectorAll('p, span, strong, em, b, i').forEach(clearPaint);
          title.style.willChange = '';
        });
      });

      /* 无 GSAP 时回落终态，避免标题一直浅色 */
      const fallbackTimer = window.setTimeout(() => {
        if (!gsapBound) paintEnd();
      }, 4500);
      this._insideTitleCleanups.push(() => {
        window.clearTimeout(fallbackTimer);
        if (typeof cancelGsapWait === 'function') cancelGsapWait();
      });
    }

    /** 一图懂卡：封面 + 静音循环视频（对齐 KV） */
    initGlanceLoopVideo() {
      const card = this.querySelector('[data-npt-glance-loop-card]');
      const video = card ? card.querySelector('[data-npt-glance-loop-video]') : null;
      const poster = card ? card.querySelector('[data-npt-glance-loop-poster]') : null;
      if (!(video instanceof HTMLVideoElement)) {
        this._nptPlayGlanceLoopVideo = null;
        return;
      }

      let started = false;
      const playLoop = () => {
        if (started) {
          nptRestoreAndPlayInlineVideo(video);
          return;
        }
        started = true;
        try {
          video.loop = true;
          video.muted = true;
          video.playsInline = true;
          video.preload = 'auto';
        } catch (_) {}

        const reveal = () => {
          if (!video.isConnected) return;
          video.classList.add('is-visible');
          if (poster instanceof HTMLElement) poster.classList.add('is-hidden');
          nptRestoreAndPlayInlineVideo(video);
        };

        if (video.readyState >= 3) {
          reveal();
        } else {
          video.addEventListener('canplay', reveal, { once: true });
          video.addEventListener('loadeddata', reveal, { once: true });
          try {
            video.load();
          } catch (_) {}
        }
      };

      const pauseLoop = () => {
        nptPauseInlineVideo(video, true);
      };

      this._nptPlayGlanceLoopVideo = playLoop;

      this._seriesRevealCleanups = this._seriesRevealCleanups || [];
      /* 进视口播放 / 离视口 pause + 卸 src */
      if (card instanceof HTMLElement) {
        this._seriesRevealCleanups.push(
          nptBindViewportVideo(video, {
            observeEl: card,
            threshold: 0.15,
            onVisible: playLoop,
            onHidden: pauseLoop,
          })
        );
      } else {
        playLoop();
      }

      const section = this.querySelector('[data-npt-series-glance]');
      if (section instanceof HTMLElement && section.classList.contains('is-glance-docked')) {
        playLoop();
      }
    }

    /** KV 双视频：resize 节流 + 断点切换播放 + 视口内外 pause */
    initKvVideo() {
      const kv = this.querySelector('[data-npt-kv]');
      if (!(kv instanceof HTMLElement)) return;
      this._runCleanups(this._kvVideoCleanups || (this._kvVideoCleanups = []));

      const posterImg = kv.querySelector('.ug-nexode-pro-template__kv-poster');
      const posterPicture = kv.querySelector('.ug-nexode-pro-template__kv-poster-picture');
      const kvInner = kv.querySelector('.ug-nexode-pro-template__kv-inner');
      let lastIsMobile = null;

      const revealKvInner = () => {
        if (!this.isConnected || !(kvInner instanceof HTMLElement)) return;
        kvInner.classList.add('is-revealed');
        if (this._kvRevealFallbackTimer) {
          window.clearTimeout(this._kvRevealFallbackTimer);
          this._kvRevealFallbackTimer = 0;
        }
      };

      /* 减动效或无视频：直接展示文案 */
      if (nptPrefersReducedMotion()) {
        revealKvInner();
      }

      /* 播放到 70% 时露出文案，或 ended */
      const KV_REVEAL_PROGRESS = 0.7;
      const maybeRevealByProgress = (video) => {
        if (!(video instanceof HTMLVideoElement)) return;
        const d = video.duration;
        if (!Number.isFinite(d) || d <= 0) {
          if (video.ended) revealKvInner();
          return;
        }
        if (video.currentTime / d >= KV_REVEAL_PROGRESS || video.ended) revealKvInner();
      };
      const bindKvProgressReveal = (video) => {
        if (!(video instanceof HTMLVideoElement)) return;
        if (video.dataset.nptKvRevealBound === '1') {
          maybeRevealByProgress(video);
          return;
        }
        video.dataset.nptKvRevealBound = '1';
        video.addEventListener('timeupdate', () => maybeRevealByProgress(video));
        video.addEventListener('ended', revealKvInner);
        maybeRevealByProgress(video);
      };

      const sync = () => {
        const isMobile = window.matchMedia(MOBILE_MQ).matches;
        if (lastIsMobile !== null && lastIsMobile === isMobile) return;
        lastIsMobile = isMobile;

        const active = isMobile
          ? kv.querySelector('.ug-nexode-pro-template__kv-video--mo')
          : kv.querySelector('.ug-nexode-pro-template__kv-video--pc');
        const inactive = isMobile
          ? kv.querySelector('.ug-nexode-pro-template__kv-video--pc')
          : kv.querySelector('.ug-nexode-pro-template__kv-video--mo');

        if (inactive instanceof HTMLVideoElement) {
          try {
            inactive.pause();
            inactive.preload = 'none';
          } catch (_) {}
          inactive.classList.remove('is-visible');
        }
        if (!(active instanceof HTMLVideoElement)) {
          revealKvInner();
          return;
        }

        try {
          active.loop = false;
          active.preload = 'auto';
        } catch (_) {}

        const srcEl = active.querySelector('source');
        const src = srcEl && srcEl.getAttribute('src');
        if (!src || src.trim() === '') {
          revealKvInner();
          return;
        }

        bindKvProgressReveal(active);

        /* 防止 ended 未触发：最长等待后仍露出文案 */
        if (this._kvRevealFallbackTimer) window.clearTimeout(this._kvRevealFallbackTimer);
        if (!(kvInner instanceof HTMLElement) || !kvInner.classList.contains('is-revealed')) {
          this._kvRevealFallbackTimer = window.setTimeout(revealKvInner, 12000);
        }

        const tryPlay = () => {
          if (!this.isConnected || !active.isConnected) return;
          active.classList.add('is-visible');
          if (posterImg instanceof HTMLElement) posterImg.classList.add('is-hidden');
          if (posterPicture instanceof HTMLElement) posterPicture.classList.add('is-hidden');
          nptPlayInlineVideo(active);
        };

        if (active.readyState >= 3) {
          tryPlay();
        } else {
          active.addEventListener('canplay', tryPlay, { once: true });
          active.addEventListener('loadeddata', tryPlay, { once: true });
          try {
            active.load();
          } catch (_) {}
        }
      };

      const scheduleSync = () => {
        if (this._kvResizeRaf) window.cancelAnimationFrame(this._kvResizeRaf);
        this._kvResizeRaf = window.requestAnimationFrame(() => {
          this._kvResizeRaf = 0;
          sync();
        });
      };

      let kvInView = true;
      const pauseAllKv = () => {
        kv.querySelectorAll('video').forEach((v) => {
          if (v instanceof HTMLVideoElement) nptPauseInlineVideo(v, false);
        });
      };
      const playIfInView = () => {
        if (!kvInView) {
          pauseAllKv();
          return;
        }
        lastIsMobile = null;
        sync();
      };

      scheduleSync();
      this._kvVideoCleanups = this._kvVideoCleanups || [];
      this._kvVideoCleanups.push(
        nptObserveInView(
          kv,
          (visible) => {
            kvInView = visible;
            playIfInView();
          },
          { threshold: 0.08 }
        )
      );

      if (this.dataset.nptVideoResizeBound === '1') return;
      this.dataset.nptVideoResizeBound = '1';
      this._onVideoResize = () => {
        if (!kvInView) return;
        scheduleSync();
      };
      window.addEventListener('resize', this._onVideoResize, { passive: true });
    }

    /**
     * KV 二级导航：fixed；滚过 KV 底部后滑入，滚回则收起（对齐 Air）。
     * 手机端：第二行锚点区下滑收起、上滑展开（Figma 注释）。
     */
    initKvNav() {
      this._teardownKvNav();

      const nav = this.querySelector('[data-npt-kv-nav]');
      if (!(nav instanceof HTMLElement)) return;

      const root = this;
      const kvEl = root.querySelector('[data-npt-kv]');
      const buyBtn = nav.querySelector('[data-npt-kv-nav-buy]');
      const reduced = nptPrefersReducedMotion();
      const mqMobile = window.matchMedia(MOBILE_MQ);

      let kvRevealThreshold = 0;
      let lastSy = window.scrollY || window.pageYOffset || 0;
      let scrollTicking = false;
      let scrollRaf = 0;

      const measureKvRevealThreshold = () => {
        if (kvEl instanceof HTMLElement) {
          const rect = kvEl.getBoundingClientRect();
          const sy0 = window.scrollY || window.pageYOffset || 0;
          kvRevealThreshold = Math.max(0, Math.round(rect.bottom + sy0));
          return;
        }
        kvRevealThreshold = 0;
      };

      const finishLeave = () => {
        nav.removeEventListener('animationend', onLeaveAnimEnd);
        nav.classList.remove('is-kv-sticky', 'is-kv-sticky-leaving', 'is-anchors-collapsed');
        nav.classList.add('is-kv-nav-before-kv');
        nav.setAttribute('aria-hidden', 'true');
        lastSy = window.scrollY || window.pageYOffset || 0;
        window.requestAnimationFrame(() => {
          measureKvRevealThreshold();
        });
      };

      const onLeaveAnimEnd = (ev) => {
        if (!(ev instanceof AnimationEvent)) return;
        if (ev.target !== nav) return;
        if (ev.animationName !== 'ug-npt-kv-nav-slide-out') return;
        finishLeave();
      };

      const startLeave = () => {
        if (!nav.classList.contains('is-kv-sticky') || nav.classList.contains('is-kv-sticky-leaving')) {
          return;
        }
        if (reduced) {
          finishLeave();
          return;
        }
        nav.classList.add('is-kv-sticky-leaving');
        nav.addEventListener('animationend', onLeaveAnimEnd);
      };

      const revealSticky = () => {
        if (nav.classList.contains('is-kv-nav-before-kv')) {
          nav.classList.remove('is-kv-nav-before-kv');
          nav.removeAttribute('aria-hidden');
          if (!reduced) {
            void nav.offsetHeight;
          }
          nav.classList.remove('is-kv-sticky-leaving');
          nav.classList.add('is-kv-sticky');
          /* 刚露出时默认展开第二行 */
          nav.classList.remove('is-anchors-collapsed');
          return true;
        }
        if (!nav.classList.contains('is-kv-sticky')) {
          nav.classList.add('is-kv-sticky');
        }
        return false;
      };

      /** sticky 显隐 + 手机端第二行方向收展，共用一套 rAF / lastSy */
      const onScrollFrame = () => {
        scrollTicking = false;
        scrollRaf = 0;
        if (!nav.isConnected) return;
        const sy = window.scrollY || window.pageYOffset || 0;
        const delta = sy - lastSy;
        const wantVisible = sy >= kvRevealThreshold;
        let justRevealed = false;

        if (nav.classList.contains('is-kv-sticky-leaving')) {
          if (wantVisible) {
            nav.removeEventListener('animationend', onLeaveAnimEnd);
            nav.classList.remove('is-kv-sticky-leaving');
            nav.classList.add('is-kv-sticky');
          }
          lastSy = sy;
          return;
        }

        if (wantVisible) {
          justRevealed = revealSticky();
        } else if (nav.classList.contains('is-kv-sticky')) {
          startLeave();
          lastSy = sy;
          return;
        } else if (!nav.classList.contains('is-kv-nav-before-kv')) {
          nav.classList.add('is-kv-nav-before-kv');
          nav.setAttribute('aria-hidden', 'true');
          nav.classList.remove('is-anchors-collapsed');
          lastSy = sy;
          return;
        }

        /* 手机：下滑收起第二行，上滑展开（刚滑入时跳过，避免立刻折叠） */
        if (
          mqMobile.matches &&
          !justRevealed &&
          nav.classList.contains('is-kv-sticky') &&
          !nav.classList.contains('is-kv-sticky-leaving') &&
          Math.abs(delta) >= NPT_KV_NAV_SCROLL_DIR_THRESHOLD_PX
        ) {
          if (delta > 0) {
            nav.classList.add('is-anchors-collapsed');
          } else {
            nav.classList.remove('is-anchors-collapsed');
          }
        } else if (!mqMobile.matches) {
          nav.classList.remove('is-anchors-collapsed');
        }

        lastSy = sy;
      };

      const requestScrollUpdate = () => {
        if (scrollTicking) return;
        scrollTicking = true;
        scrollRaf = window.requestAnimationFrame(onScrollFrame);
      };

      const onResize = () => {
        measureKvRevealThreshold();
        if (!mqMobile.matches) {
          nav.classList.remove('is-anchors-collapsed');
        }
        requestScrollUpdate();
      };

      measureKvRevealThreshold();
      requestScrollUpdate();

      window.addEventListener('scroll', requestScrollUpdate, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
      this._navCleanups.push(() => window.removeEventListener('scroll', requestScrollUpdate));
      this._navCleanups.push(() => window.removeEventListener('resize', onResize));
      this._navCleanups.push(() => {
        if (scrollRaf) {
          window.cancelAnimationFrame(scrollRaf);
          scrollRaf = 0;
        }
        scrollTicking = false;
        nav.removeEventListener('animationend', onLeaveAnimEnd);
        nav.classList.remove(
          'is-kv-sticky',
          'is-kv-sticky-leaving',
          'is-kv-nav-before-kv',
          'is-anchors-collapsed'
        );
        nav.removeAttribute('aria-hidden');
      });

      const onAnchorClick = (ev) => {
        const link = ev.currentTarget;
        if (!(link instanceof HTMLAnchorElement)) return;
        const target = nptResolveScrollTarget(link, root);
        if (!target) return;
        ev.preventDefault();
        nptJumpToPageAnchor(target, nav, reduced);
      };

      const anchorEls = Array.from(nav.querySelectorAll('[data-npt-kv-nav-anchor]'));
      anchorEls.forEach((el) => {
        el.addEventListener('click', onAnchorClick);
        this._navCleanups.push(() => el.removeEventListener('click', onAnchorClick));
      });

      const onBuyNowClick = (ev) => {
        if (!(buyBtn instanceof HTMLAnchorElement)) return;
        const href = (buyBtn.getAttribute('href') || '').trim();
        const scrollSel = (buyBtn.getAttribute('data-npt-scroll-target') || '').trim();
        /* 配置了非页内锚点链接（集合等）：走浏览器默认跳转 */
        if (!scrollSel && href && href.charAt(0) !== '#') {
          return;
        }
        const target =
          nptResolveScrollTarget(buyBtn, root) ||
          nptGetTargetByHash(nptGetHashFromHref(href), root) ||
          root.querySelector('[data-npt-showcase]');
        if (!target) return;
        ev.preventDefault();
        nptJumpToPageAnchor(target, nav, reduced);
      };
      if (buyBtn instanceof HTMLElement) {
        buyBtn.addEventListener('click', onBuyNowClick);
        this._navCleanups.push(() => buyBtn.removeEventListener('click', onBuyNowClick));
      }
    }

    /**
     * 产品卖点：主卡 hover 切换；桌面首次 scrub 入场/退场，一切换即钉终态。
     */
    initShowcase() {
      this._teardownShowcase();
      const root = this.querySelector('[data-npt-showcase]');
      if (!(root instanceof HTMLElement)) return;

      const stages = Array.from(root.querySelectorAll('[data-npt-showcase-stage]'));
      const mains = Array.from(root.querySelectorAll('[data-npt-showcase-main]'));
      const deskMq = window.matchMedia('(min-width: 1024px)');
      const noAnim = !deskMq.matches || nptPrefersReducedMotion();

      let activeKey = (
        stages.find((el) => el.classList.contains('is-active')) || stages[0]
      )?.getAttribute('data-npt-showcase-key');
      let switchTl = null;
      let switchToken = 0;
      let introTl = null;
      let introSealed = noAnim;
      let cardsIntroDone = noAnim;
      let gsapRef = null;
      let stageWrapEl = null;
      const cardSections = [
        root.querySelector('[data-npt-showcase-mains]'),
        root.querySelector('[data-npt-showcase-list]'),
      ].filter((el) => el instanceof HTMLElement);

      const setActiveClasses = (key) => {
        const k = String(key);
        activeKey = k;
        stages.forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-npt-showcase-key') === k);
        });
        mains.forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-npt-showcase-key') === k);
        });
      };

      const stageAnimTargets = (stage) => {
        const parts = nptStageParts(stage);
        const list = [stage, parts.product, parts.title, parts.disclaimer];
        parts.callouts.forEach((c) => {
          const bits = nptCalloutBits(c);
          list.push(bits.card, bits.line, bits.dot);
        });
        return list.filter(Boolean);
      };

      const clearStageInline = (stage) => {
        if (!gsapRef) return;
        gsapRef.set(stageAnimTargets(stage), { clearProps: 'opacity,visibility,zIndex,transform' });
      };

      const setStageCopyState = (gsap, parts, visible) => {
        if (parts.title) gsap.set(parts.title, { opacity: visible ? 1 : 0, y: visible ? 0 : 24 });
        if (parts.disclaimer) {
          gsap.set(parts.disclaimer, { opacity: visible ? 1 : 0, y: visible ? 0 : 20 });
        }
        parts.callouts.forEach((callout) => {
          const { card, line, dot } = nptCalloutBits(callout);
          if (card) {
            gsap.set(card, {
              opacity: visible ? 1 : 0,
              x: visible ? 0 : nptCalloutCardFromX(callout),
            });
          }
          if (line) gsap.set(line, { scaleX: visible ? 1 : 0, opacity: visible ? 1 : 0 });
          if (dot) gsap.set(dot, { scale: visible ? 1 : 0, opacity: visible ? 1 : 0 });
        });
      };

      const setProductState = (gsap, product, { scale, y, opacity }) => {
        if (!product) return;
        /* 居中交给 CSS margin，这里只做 scale/y，避免冲掉 translate(-50%) */
        gsap.set(product, {
          y,
          scale,
          opacity,
          force3D: true,
        });
      };

      const pinCards = () => {
        if (!gsapRef || !cardSections.length || !cardsIntroDone) return;
        gsapRef.set(cardSections, { opacity: 1, y: 0 });
      };

      const playCardsOnce = (progress) => {
        if (cardsIntroDone || !gsapRef || !cardSections.length || progress < 0.72) return;
        cardsIntroDone = true;
        gsapRef.to(cardSections, {
          opacity: 1,
          y: 0,
          duration: 0.35,
          stagger: 0.08,
          ease: 'sine.out',
          overwrite: 'auto',
        });
      };

      const killIntro = () => {
        if (!introTl) return;
        const st = introTl.scrollTrigger;
        if (st) st.kill(false);
        introTl.kill();
        introTl = null;
        pinCards();
      };

      const pinStageFinal = (stage) => {
        if (!gsapRef || !(stage instanceof HTMLElement)) return;
        const parts = nptStageParts(stage);
        setStageCopyState(gsapRef, parts, true);
        setProductState(gsapRef, parts.product, { scale: 1, y: 0, opacity: 1 });
        gsapRef.set(stage, { autoAlpha: 1, zIndex: 1 });
      };

      const hideOtherStages = (keep) => {
        stages.forEach((stage) => {
          if (stage === keep) return;
          clearStageInline(stage);
          if (gsapRef) gsapRef.set(stage, { autoAlpha: 0, zIndex: 0 });
        });
      };

      /** 仅初始化绑首次 scrub；切换后 introSealed，不再调用 */
      const bindIntro = (stage) => {
        if (introSealed || !gsapRef || !(stage instanceof HTMLElement) || !(stageWrapEl instanceof HTMLElement)) {
          return;
        }
        const gsap = gsapRef;
        const ST = window.ScrollTrigger;
        if (!ST) return;

        killIntro();
        stages.forEach((s) => {
          if (s !== stage) clearStageInline(s);
        });

        const parts = nptStageParts(stage);
        if (cardSections.length) {
          if (cardsIntroDone) pinCards();
          else gsap.set(cardSections, { opacity: 0, y: 56 });
        }
        setStageCopyState(gsap, parts, false);
        setProductState(gsap, parts.product, { scale: 3, y: 360, opacity: 1 });
        gsap.set(stage, { autoAlpha: 1, zIndex: 1 });

        introTl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            trigger: stageWrapEl,
            start: 'top 70%',
            end: 'top 15%',
            scrub: NPT_SCRUB,
            onUpdate: (self) => playCardsOnce(self.progress),
          },
        });

        const ft = (el, from, to, at) => {
          if (!el) return;
          introTl.fromTo(el, from, { ...to, immediateRender: false }, at);
        };
        ft(
          parts.product,
          { scale: 3, y: 360, opacity: 1, force3D: true },
          { scale: 1, y: 0, opacity: 1, force3D: true, duration: 0.62 },
          0
        );
        ft(parts.title, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.18 }, 0.38);
        ft(parts.disclaimer, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.16 }, 0.46);
        parts.callouts.forEach((callout, i) => {
          const { card, line, dot } = nptCalloutBits(callout);
          const t0 = 0.52 + i * 0.06;
          ft(dot, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.14 }, t0);
          ft(line, { scaleX: 0, opacity: 0 }, { scaleX: 1, opacity: 1, duration: 0.18 }, t0 + 0.1);
          ft(
            card,
            { opacity: 0, x: nptCalloutCardFromX(callout) },
            { opacity: 1, x: 0, duration: 0.18 },
            t0 + 0.2
          );
        });

        ST.update();
        if (introTl.scrollTrigger) playCardsOnce(introTl.scrollTrigger.progress);
        pinCards();
      };

      const settleStagesTo = (keepKey) => {
        if (!gsapRef) return;
        pinCards();
        const k = String(keepKey);
        stages.forEach((stage) => {
          gsapRef.killTweensOf(stageAnimTargets(stage));
          if (stage.getAttribute('data-npt-showcase-key') === k) pinStageFinal(stage);
          else gsapRef.set(stage, { autoAlpha: 0, zIndex: 0 });
        });
      };

      const finishSwitchTo = (key, toStage) => {
        introSealed = true;
        killIntro();
        setActiveClasses(key);
        pinCards();
        hideOtherStages(toStage);
        pinStageFinal(toStage);
      };

      const playSwitch = (fromStage, toStage, key) => {
        const gsap = gsapRef;
        const token = ++switchToken;
        if (switchTl) {
          switchTl.kill();
          switchTl = null;
        }
        introSealed = true;
        killIntro();
        pinCards();
        settleStagesTo(fromStage.getAttribute('data-npt-showcase-key'));

        const from = nptStageParts(fromStage);
        const to = nptStageParts(toStage);
        stages.forEach((el) => el.classList.toggle('is-active', el === toStage));
        gsap.set(fromStage, { autoAlpha: 1, zIndex: 1 });
        gsap.set(toStage, { autoAlpha: 1, zIndex: 2 });
        setStageCopyState(gsap, to, false);
        setProductState(gsap, to.product, { scale: 1.06, y: 0, opacity: 0 });

        switchTl = gsap.timeline({
          defaults: { ease: 'sine.inOut' },
          onComplete: () => {
            if (token !== switchToken) return;
            finishSwitchTo(key, toStage);
            switchTl = null;
          },
        });

        if (from.product) {
          switchTl.to(from.product, { scale: 1.06, opacity: 0, duration: 0.2, ease: 'sine.in' }, 0);
        }
        if (from.title) switchTl.to(from.title, { opacity: 0, y: -10, duration: 0.16, ease: 'sine.in' }, 0);
        if (from.disclaimer) {
          switchTl.to(from.disclaimer, { opacity: 0, y: -8, duration: 0.14, ease: 'sine.in' }, 0);
        }
        from.callouts.forEach((callout) => {
          const { card, line, dot } = nptCalloutBits(callout);
          if (card) {
            switchTl.to(
              card,
              { opacity: 0, x: nptCalloutCardFromX(callout), duration: 0.16, ease: 'sine.in' },
              0.02
            );
          }
          if (line) switchTl.to(line, { scaleX: 0, opacity: 0, duration: 0.14, ease: 'sine.in' }, 0.02);
          if (dot) switchTl.to(dot, { scale: 0.6, opacity: 0, duration: 0.12, ease: 'sine.in' }, 0.04);
        });
        switchTl.to(fromStage, { autoAlpha: 0, duration: 0.16, ease: 'sine.in' }, 0.06);

        if (to.product) {
          switchTl.to(to.product, { scale: 1, opacity: 1, duration: 0.58, ease: 'sine.out' }, 0.12);
        }
        if (to.title) {
          switchTl.fromTo(
            to.title,
            { opacity: 0, y: 18 },
            { opacity: 1, y: 0, duration: 0.5, ease: 'sine.out' },
            0.18
          );
        }
        if (to.disclaimer) {
          switchTl.fromTo(
            to.disclaimer,
            { opacity: 0, y: 16 },
            { opacity: 1, y: 0, duration: 0.46, ease: 'sine.out' },
            0.22
          );
        }
        to.callouts.forEach((callout, i) => {
          const { card, line, dot } = nptCalloutBits(callout);
          const t0 = 0.26 + i * 0.05;
          if (dot) switchTl.to(dot, { scale: 1, opacity: 1, duration: 0.32, ease: 'sine.out' }, t0);
          if (line) switchTl.to(line, { scaleX: 1, opacity: 1, duration: 0.4, ease: 'sine.out' }, t0 + 0.1);
          if (card) {
            switchTl.fromTo(
              card,
              { opacity: 0, x: nptCalloutCardFromX(callout) },
              { opacity: 1, x: 0, duration: 0.42, ease: 'sine.out' },
              t0 + 0.2
            );
          }
        });
      };

      const activate = (key) => {
        const k = String(key);
        if (k === activeKey && !switchTl) return;

        mains.forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-npt-showcase-key') === k);
        });

        if (noAnim || !gsapRef) {
          if (switchTl) {
            switchToken += 1;
            switchTl.kill();
            switchTl = null;
          }
          setActiveClasses(k);
          return;
        }

        const fromStage = stages.find((el) => el.getAttribute('data-npt-showcase-key') === activeKey);
        const toStage = stages.find((el) => el.getAttribute('data-npt-showcase-key') === k);
        if (!(toStage instanceof HTMLElement)) {
          setActiveClasses(k);
          return;
        }
        if (!(fromStage instanceof HTMLElement) || fromStage === toStage) {
          if (switchTl) {
            switchToken += 1;
            switchTl.kill();
            switchTl = null;
            settleStagesTo(k);
          }
          finishSwitchTo(k, toStage);
          return;
        }
        activeKey = k;
        playSwitch(fromStage, toStage, k);
      };

      mains.forEach((card) => {
        const onEnter = () => {
          /* 仅桌面轮播：半截溢出卡不切换主推（与 CSS 双保险） */
          const slide = card.closest('.swiper-slide');
          const inDesktopSlider =
            slide &&
            slide.closest('.ug-nexode-pro-template__showcase-mains.is-slider') &&
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(min-width: 1024px)').matches;
          if (
            inDesktopSlider &&
            !slide.classList.contains('swiper-slide-fully-visible') &&
            !slide.classList.contains('swiper-slide-active')
          ) {
            return;
          }
          activate(card.getAttribute('data-npt-showcase-key'));
        };
        card.addEventListener('mouseenter', onEnter);
        this._showcaseCleanups.push(() => card.removeEventListener('mouseenter', onEnter));
      });

      /* Buy 商详链接：跳过 View Transition，避免整页淡出闪一下 */
      const onBuyLinkClick = (e) => {
        const link = e.target instanceof Element
          ? e.target.closest('a.ug-nexode-air-template__charge-promo-buy[data-na-buy-product-link]')
          : null;
        if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;
        if (link.hasAttribute('data-na-cta-retail-direct') || link.hasAttribute('data-na-cta-retail-external')) {
          return;
        }
        document.documentElement.dataset.nptSkipVt = '1';
      };
      const onNptPageSwap = (event) => {
        if (document.documentElement.dataset.nptSkipVt !== '1') return;
        delete document.documentElement.dataset.nptSkipVt;
        const vt = event && event.viewTransition;
        if (vt && typeof vt.skipTransition === 'function') vt.skipTransition();
      };
      this.addEventListener('click', onBuyLinkClick, true);
      window.addEventListener('pageswap', onNptPageSwap);
      this._showcaseCleanups.push(() => {
        this.removeEventListener('click', onBuyLinkClick, true);
        window.removeEventListener('pageswap', onNptPageSwap);
        delete document.documentElement.dataset.nptSkipVt;
      });

      /* 复用主题全局 Swiper（scripts.liquid 已 defer，等待就绪再拿重复加载） */
      const cancelShowcaseSwiperWait = nptWhenSwiperReady((SwiperCtor) => {
        if (!this.isConnected || !root.isConnected) return;
        const mainsWrap = root.querySelector('[data-npt-showcase-mains]');
        const mainsCount =
          Number(mainsWrap && mainsWrap.getAttribute('data-npt-showcase-main-count')) || mains.length;
        const mainsEl = mainsWrap && mainsWrap.querySelector('[data-npt-showcase-mains-swiper]');
        const mainsDeskMq =
          typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1024px)') : null;
        /* 手机纵向堆叠；桌面且 >2 张时开 Swiper，断点变化时重建 */
        let mainsSwiper = null;
        const syncMainsSwiper = () => {
          const want =
            !!SwiperCtor &&
            mainsEl instanceof HTMLElement &&
            mainsCount > 2 &&
            !!(mainsDeskMq && mainsDeskMq.matches);
          if (want && !mainsSwiper) {
            mainsSwiper = new SwiperCtor(mainsEl, {
              slidesPerView: 2,
              spaceBetween: 16,
              watchSlidesProgress: true,
              speed: 480,
              navigation: {
                prevEl: mainsWrap.querySelector('[data-npt-showcase-mains-prev]'),
                nextEl: mainsWrap.querySelector('[data-npt-showcase-mains-next]'),
              },
              on: {
                slideChange(sw) {
                  const slide = sw.slides[sw.activeIndex];
                  const card = slide && slide.querySelector('[data-npt-showcase-main]');
                  if (card) activate(card.getAttribute('data-npt-showcase-key'));
                },
              },
            });
          } else if (!want && mainsSwiper) {
            try {
              mainsSwiper.destroy(true, true);
            } catch (_) {}
            mainsSwiper = null;
          }
        };
        syncMainsSwiper();
        if (mainsDeskMq) {
          const onMainsMq = () => syncMainsSwiper();
          if (typeof mainsDeskMq.addEventListener === 'function') {
            mainsDeskMq.addEventListener('change', onMainsMq);
            this._showcaseCleanups.push(() => mainsDeskMq.removeEventListener('change', onMainsMq));
          } else if (typeof mainsDeskMq.addListener === 'function') {
            mainsDeskMq.addListener(onMainsMq);
            this._showcaseCleanups.push(() => mainsDeskMq.removeListener(onMainsMq));
          }
        }
        this._showcaseCleanups.push(() => {
          if (!mainsSwiper) return;
          try {
            mainsSwiper.destroy(true, true);
          } catch (_) {}
          mainsSwiper = null;
        });

        const listWrap = root.querySelector('[data-npt-showcase-list]');
        if (listWrap) {
          const el = listWrap.querySelector('[data-npt-showcase-list-swiper]');
          const barFill = listWrap.querySelector('[data-npt-showcase-list-bar-fill]');
          if (el) {
            const listMobileMq =
              typeof window.matchMedia === 'function'
                ? window.matchMedia('(max-width: 1023.98px)')
                : null;
            /* 仅手机阿语从右往左；桌面仍从左往右，避免和外侧箭头拧着 */
            const syncListDirection = (swiper) => {
              if (document.documentElement.getAttribute('dir') !== 'rtl') return 'ltr';
              const rtl = !!(listMobileMq && listMobileMq.matches);
              const dir = rtl ? 'rtl' : 'ltr';
              el.dir = dir;
              el.style.direction = dir;
              if (swiper && swiper.rtl !== rtl && typeof swiper.changeLanguageDirection === 'function') {
                swiper.changeLanguageDirection(dir);
              }
              return dir;
            };
            syncListDirection(null);
            const listSwiper = new SwiperCtor(el, {
              /* 手机：设计稿 198 宽卡 + 10 间距，露出下一张 */
              slidesPerView: 'auto',
              spaceBetween: 10,
              watchSlidesProgress: true,
              watchOverflow: true,
              speed: 450,
              navigation: {
                prevEl: listWrap.querySelector('[data-npt-showcase-list-prev]'),
                nextEl: listWrap.querySelector('[data-npt-showcase-list-next]'),
              },
              breakpoints: {
                /* 4×308 + 3×16 = 1280，与主推同宽左右对齐；溢出卡半透明 */
                1024: { slidesPerView: 4, spaceBetween: 16 },
              },
              on: {
                init(sw) {
                  sw.update();
                },
                slideChange(sw) {
                  /* 刷新 fully-visible / active，保证切换后高亮 */
                  sw.updateSlidesClasses();
                },
                resize(sw) {
                  sw.update();
                },
                progress(sw, progress) {
                  if (!(barFill instanceof HTMLElement)) return;
                  const p = Math.max(0, Math.min(1, progress));
                  barFill.style.width = `${Math.max(20, p * 100)}%`;
                },
              },
            });
            if (listMobileMq && document.documentElement.getAttribute('dir') === 'rtl') {
              const onListDirChange = () => syncListDirection(listSwiper);
              if (typeof listMobileMq.addEventListener === 'function') {
                listMobileMq.addEventListener('change', onListDirChange);
                this._showcaseCleanups.push(() => listMobileMq.removeEventListener('change', onListDirChange));
              } else if (typeof listMobileMq.addListener === 'function') {
                listMobileMq.addListener(onListDirChange);
                this._showcaseCleanups.push(() => listMobileMq.removeListener(onListDirChange));
              }
            }
            this._showcaseCleanups.push(() => listSwiper.destroy(true, true));
          }
        }
      });
      this._showcaseCleanups.push(cancelShowcaseSwiperWait);

      /* 桌面：首次 scrub；手机跳过 */
      if (!noAnim && stages.length) {
        const cancelGsapWait = nptWhenGsapReady((gsap, ScrollTrigger) => {
          gsapRef = gsap;
          stageWrapEl = root.querySelector('[data-npt-showcase-stages]');
          const activeStage =
            stages.find((el) => el.getAttribute('data-npt-showcase-key') === activeKey) || stages[0];
          if (!(stageWrapEl instanceof HTMLElement) || !(activeStage instanceof HTMLElement)) {
            introSealed = true;
            return;
          }

          root.classList.add('is-showcase-gsap');
          bindIntro(activeStage);

          let didRefresh = false;
          const refreshOnce = () => {
            if (didRefresh || switchTl) return;
            didRefresh = true;
            ScrollTrigger.refresh();
            ScrollTrigger.update();
            pinCards();
          };
          if (document.readyState === 'complete') {
            requestAnimationFrame(refreshOnce);
          } else {
            window.addEventListener('load', refreshOnce, { once: true });
            this._showcaseCleanups.push(() => window.removeEventListener('load', refreshOnce));
          }

          this._showcaseCleanups.push(() => {
            killIntro();
            if (switchTl) {
              switchToken += 1;
              switchTl.kill();
              switchTl = null;
            }
            stages.forEach(clearStageInline);
            if (cardSections.length) gsap.set(cardSections, { clearProps: 'opacity,transform' });
            root.classList.remove('is-showcase-gsap');
            gsapRef = null;
            stageWrapEl = null;
          });
        });
        this._showcaseCleanups.push(cancelGsapWait);
      } else {
        introSealed = true;
        cardsIntroDone = true;
      }
    }

    /** 渠道 Buy 下拉：与 Air initNexodeAirBuyDropdowns 同逻辑（PC hover / 手机点击弹层） */
    initBuyDropdowns() {
      const wraps = Array.from(this.querySelectorAll('[data-na-buy-dropdown]')).filter((wrap) => {
        /* 场景轮播克隆卡不绑下拉，避免弹层错位/重复 */
        return !(wrap instanceof HTMLElement && wrap.closest('[data-npt-scenes-clone]'));
      });
      if (!wraps.length) return;

      const cleanups = this._showcaseCleanups;
      const mqBuyDdDesk =
        typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1024px)') : null;
      const mqBuyDdMobile =
        typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_MQ) : null;
      /* 仅桌面 hover 打开；手机一律点击 + 弹层（对齐 Air） */
      const prefersHoverOpen =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !!(mqBuyDdDesk && mqBuyDdDesk.matches);

      const hoverLeaveTimers = new WeakMap();
      const HOVER_LEAVE_MS = 160;
      const buyDdModalPortalOwner = new WeakMap();
      /* 桌面面板挂 body：Swiper wrapper 的 transform + overflow:visible 仍会裁切（对齐 Air 手机挂 body） */
      const buyDdPanelPortalOwner = new WeakMap();

      const restoreBuyDdModalToWrap = (modalEl) => {
        if (!(modalEl instanceof HTMLElement)) return;
        const owner = buyDdModalPortalOwner.get(modalEl);
        if (!(owner instanceof HTMLElement) || !owner.isConnected) return;
        if (modalEl.parentNode === document.body && modalEl.parentNode !== owner) {
          try {
            owner.appendChild(modalEl);
          } catch (_) {}
        }
      };

      const clearDeskPanelInlinePos = (panelEl) => {
        if (!(panelEl instanceof HTMLElement)) return;
        panelEl.style.removeProperty('position');
        panelEl.style.removeProperty('left');
        panelEl.style.removeProperty('top');
        panelEl.style.removeProperty('right');
        panelEl.style.removeProperty('bottom');
        panelEl.style.removeProperty('width');
        panelEl.style.removeProperty('z-index');
        panelEl.removeAttribute('data-npt-dd-portaled');
        panelEl.removeAttribute('data-npt-dd-open');
      };

      const restoreBuyDdPanelToOwner = (panelEl) => {
        if (!(panelEl instanceof HTMLElement)) return;
        const owner = buyDdPanelPortalOwner.get(panelEl);
        clearDeskPanelInlinePos(panelEl);
        if (!(owner instanceof HTMLElement) || !owner.isConnected) return;
        if (panelEl.parentNode === document.body && panelEl.parentNode !== owner) {
          try {
            owner.appendChild(panelEl);
          } catch (_) {}
        }
      };

      const positionDeskPanel = (panelEl, toggleEl) => {
        if (!(panelEl instanceof HTMLElement) || !(toggleEl instanceof HTMLElement)) return;
        const r = toggleEl.getBoundingClientRect();
        const width = Math.max(Math.round(r.width), 200);
        const gap = 8;
        const panelH = Math.max(panelEl.offsetHeight || 0, 96);
        const spaceBelow = window.innerHeight - r.bottom;
        const openUp = spaceBelow < panelH + gap && r.top > panelH + gap;
        panelEl.style.position = 'fixed';
        panelEl.style.left = `${Math.round(r.left)}px`;
        panelEl.style.width = `${width}px`;
        panelEl.style.right = 'auto';
        panelEl.style.zIndex = '2147483000';
        if (openUp) {
          panelEl.style.top = 'auto';
          panelEl.style.bottom = `${Math.round(window.innerHeight - r.top + gap)}px`;
        } else {
          panelEl.style.bottom = 'auto';
          panelEl.style.top = `${Math.round(r.bottom + gap)}px`;
        }
      };

      const mountDeskPanelToBody = (panelEl, toggleEl) => {
        if (!(mqBuyDdDesk && mqBuyDdDesk.matches)) return;
        if (!(panelEl instanceof HTMLElement) || !(toggleEl instanceof HTMLElement)) return;
        if (!buyDdPanelPortalOwner.has(panelEl)) {
          buyDdPanelPortalOwner.set(panelEl, panelEl.parentElement);
        }
        if (panelEl.parentNode !== document.body) {
          document.body.appendChild(panelEl);
        }
        /* 先 0fr 再开，才能播 grid-template-rows 渐展 */
        panelEl.setAttribute('data-npt-dd-portaled', '1');
        panelEl.removeAttribute('data-npt-dd-open');
        positionDeskPanel(panelEl, toggleEl);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (panelEl.parentNode !== document.body) return;
            panelEl.setAttribute('data-npt-dd-open', '1');
            positionDeskPanel(panelEl, toggleEl);
          });
        });
      };

      const setBuyDdModalDomOpen = (modalEl, open) => {
        if (!(modalEl instanceof HTMLElement)) return;
        if (open) modalEl.setAttribute('data-na-buy-modal-open', '1');
        else modalEl.removeAttribute('data-na-buy-modal-open');
      };

      const mountBuyDdModalToBody = (modalEl, ownerWrap) => {
        if (!(modalEl instanceof HTMLElement) || !(ownerWrap instanceof HTMLElement)) return;
        if (!(mqBuyDdMobile && mqBuyDdMobile.matches)) return;
        buyDdModalPortalOwner.set(modalEl, ownerWrap);
        if (modalEl.parentNode !== document.body) {
          document.body.appendChild(modalEl);
        }
      };

      const clearBuyDdScrollLock = () => {
        document.documentElement.classList.remove('na-buy-dd-scroll-lock');
        document.body.classList.remove('na-buy-dd-scroll-lock');
      };

      const applyBuyDdScrollLockIfMobile = () => {
        if (mqBuyDdMobile && mqBuyDdMobile.matches) {
          document.documentElement.classList.add('na-buy-dd-scroll-lock');
          document.body.classList.add('na-buy-dd-scroll-lock');
        }
      };

      const clearDdHoverLeaveTimer = (wEl) => {
        if (!(wEl instanceof HTMLElement)) return;
        const tid = hoverLeaveTimers.get(wEl);
        if (tid != null) window.clearTimeout(tid);
        hoverLeaveTimers.delete(wEl);
      };

      /** @type {{ wrap: HTMLElement; toggle: HTMLElement; panel: HTMLElement; modal: HTMLElement | null; modalDismiss: HTMLElement | null; modalClose: HTMLElement | null }[]} */
      const buyDdInstances = [];
      let nptBuyDdIdSeq = 0;
      wraps.forEach((wrap) => {
        if (!(wrap instanceof HTMLElement)) return;
        const toggle = wrap.querySelector('[data-na-buy-dropdown-toggle]');
        const panel = wrap.querySelector('[data-na-buy-dropdown-panel]');
        const modal = wrap.querySelector('[data-na-buy-dropdown-modal]');
        if (!(toggle instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
        const bddId = `npt-bdd-${++nptBuyDdIdSeq}`;
        wrap.dataset.nptBuyDdWrapId = bddId;
        panel.dataset.nptBuyDdWrapId = bddId;
        if (modal instanceof HTMLElement) modal.dataset.nptBuyDdWrapId = bddId;
        const modalDismiss =
          modal instanceof HTMLElement ? modal.querySelector('[data-na-buy-dropdown-modal-dismiss]') : null;
        const modalClose =
          modal instanceof HTMLElement ? modal.querySelector('[data-na-buy-dropdown-modal-close]') : null;
        buyDdInstances.push({
          wrap,
          toggle,
          panel,
          modal: modal instanceof HTMLElement ? modal : null,
          modalDismiss: modalDismiss instanceof HTMLElement ? modalDismiss : null,
          modalClose: modalClose instanceof HTMLElement ? modalClose : null,
        });
      });

      const closeAllInRoot = () => {
        buyDdInstances.forEach(({ wrap, toggle, panel, modal }) => {
          clearDdHoverLeaveTimer(wrap);
          if (modal) {
            setBuyDdModalDomOpen(modal, false);
            restoreBuyDdModalToWrap(modal);
          }
          restoreBuyDdPanelToOwner(panel);
          wrap.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          if (panel.dataset.naDdMounted !== '1') {
            panel.hidden = true;
          }
        });
        clearBuyDdScrollLock();
      };

      /* 桌面↔手机都关：避免 desk→mobile 时 portal 面板残留在 body */
      const onBuyDdBreakpointChange = () => {
        closeAllInRoot();
      };
      if (mqBuyDdDesk) {
        mqBuyDdDesk.addEventListener('change', onBuyDdBreakpointChange);
        cleanups.push(() => mqBuyDdDesk.removeEventListener('change', onBuyDdBreakpointChange));
      }

      const repositionOpenDeskPanels = () => {
        if (!(mqBuyDdDesk && mqBuyDdDesk.matches)) return;
        buyDdInstances.forEach(({ wrap, toggle, panel }) => {
          if (!wrap.classList.contains('is-open')) return;
          if (panel.parentNode !== document.body) return;
          positionDeskPanel(panel, toggle);
        });
      };
      window.addEventListener('scroll', repositionOpenDeskPanels, true);
      window.addEventListener('resize', repositionOpenDeskPanels);
      cleanups.push(() => {
        window.removeEventListener('scroll', repositionOpenDeskPanels, true);
        window.removeEventListener('resize', repositionOpenDeskPanels);
      });

      buyDdInstances.forEach(({ wrap, toggle, panel, modal, modalDismiss, modalClose }) => {
        wrap.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.removeAttribute('hidden');
        panel.dataset.naDdMounted = '1';

        const close = () => {
          clearDdHoverLeaveTimer(wrap);
          if (modal) {
            setBuyDdModalDomOpen(modal, false);
            restoreBuyDdModalToWrap(modal);
          }
          restoreBuyDdPanelToOwner(panel);
          wrap.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          clearBuyDdScrollLock();
        };

        const open = () => {
          if (toggle.classList.contains('is-disabled')) return;
          /* 已打开则跳过：避免 hover/focus 时 portal 面板回到按钮时重挂 body、动画闪一下 */
          if (wrap.classList.contains('is-open')) {
            clearDdHoverLeaveTimer(wrap);
            return;
          }
          clearDdHoverLeaveTimer(wrap);
          closeAllInRoot();
          panel.dataset.naDdInteractive = '1';
          wrap.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          applyBuyDdScrollLockIfMobile();
          if (modal) {
            setBuyDdModalDomOpen(modal, true);
            mountBuyDdModalToBody(modal, wrap);
          }
          /* 桌面：面板挂 body，躲开 Swiper transform 裁切 */
          mountDeskPanelToBody(panel, toggle);
        };

        if (prefersHoverOpen) {
          const scheduleClose = () => {
            clearDdHoverLeaveTimer(wrap);
            const tid = window.setTimeout(() => {
              hoverLeaveTimers.delete(wrap);
              if (wrap.matches(':hover') || panel.matches(':hover')) return;
              close();
            }, HOVER_LEAVE_MS);
            hoverLeaveTimers.set(wrap, tid);
          };
          const onEnter = () => {
            if (toggle.classList.contains('is-disabled')) return;
            clearDdHoverLeaveTimer(wrap);
            open();
          };
          const onPanelEnter = () => clearDdHoverLeaveTimer(wrap);
          wrap.addEventListener('mouseenter', onEnter);
          wrap.addEventListener('mouseleave', scheduleClose);
          panel.addEventListener('mouseenter', onPanelEnter);
          panel.addEventListener('mouseleave', scheduleClose);
          cleanups.push(() => wrap.removeEventListener('mouseenter', onEnter));
          cleanups.push(() => wrap.removeEventListener('mouseleave', scheduleClose));
          cleanups.push(() => panel.removeEventListener('mouseenter', onPanelEnter));
          cleanups.push(() => panel.removeEventListener('mouseleave', scheduleClose));

          const onFocusIn = () => {
            if (toggle.classList.contains('is-disabled')) return;
            open();
          };
          const onFocusOut = (e) => {
            const next = e.relatedTarget;
            if (next instanceof Node && wrap.contains(next)) return;
            if (next instanceof Node && panel.contains(next)) return;
            if (next instanceof Node && modal && modal.contains(next)) return;
            close();
          };
          wrap.addEventListener('focusin', onFocusIn);
          wrap.addEventListener('focusout', onFocusOut);
          panel.addEventListener('focusin', onFocusIn);
          panel.addEventListener('focusout', onFocusOut);
          cleanups.push(() => wrap.removeEventListener('focusin', onFocusIn));
          cleanups.push(() => wrap.removeEventListener('focusout', onFocusOut));
          cleanups.push(() => panel.removeEventListener('focusin', onFocusIn));
          cleanups.push(() => panel.removeEventListener('focusout', onFocusOut));

          const onToggleClickHover = (e) => {
            e.stopPropagation();
            if (toggle.classList.contains('is-disabled')) return;
            if (wrap.classList.contains('is-open')) close();
            else open();
          };
          toggle.addEventListener('click', onToggleClickHover);
          cleanups.push(() => toggle.removeEventListener('click', onToggleClickHover));
        } else {
          const onToggleClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (toggle.classList.contains('is-disabled')) return;
            if (wrap.classList.contains('is-open')) close();
            else open();
          };
          toggle.addEventListener('click', onToggleClick);
          cleanups.push(() => toggle.removeEventListener('click', onToggleClick));
        }

        const onModalDismiss = (e) => {
          e.preventDefault();
          e.stopPropagation();
          close();
        };
        if (modalDismiss) {
          modalDismiss.addEventListener('click', onModalDismiss);
          cleanups.push(() => modalDismiss.removeEventListener('click', onModalDismiss));
        }
        if (modalClose) {
          modalClose.addEventListener('click', onModalDismiss);
          cleanups.push(() => modalClose.removeEventListener('click', onModalDismiss));
        }
      });

      const onDocPointerDown = (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (
          !el ||
          el.closest('[data-na-buy-dropdown]') ||
          el.closest('[data-na-buy-dropdown-modal]') ||
          el.closest('[data-na-buy-dropdown-panel]')
        ) {
          return;
        }
        closeAllInRoot();
      };
      document.addEventListener('pointerdown', onDocPointerDown, true);
      cleanups.push(() => document.removeEventListener('pointerdown', onDocPointerDown, true));

      const onKeyDown = (e) => {
        if (e.key === 'Escape') closeAllInRoot();
      };
      document.addEventListener('keydown', onKeyDown);
      cleanups.push(() => document.removeEventListener('keydown', onKeyDown));

      cleanups.push(() => {
        buyDdInstances.forEach(({ wrap, panel, modal }) => {
          clearDdHoverLeaveTimer(wrap);
          if (modal) {
            setBuyDdModalDomOpen(modal, false);
            restoreBuyDdModalToWrap(modal);
          }
          restoreBuyDdPanelToOwner(panel);
        });
        clearBuyDdScrollLock();
      });
    }
  }

  if (!customElements.get(TAG_NAME)) {
    customElements.define(TAG_NAME, NexodeProTemplateSection);
  }

  function reinitRoot(root) {
    if (!(root instanceof HTMLElement)) return;
    delete root.dataset.nptInited;
    delete root.dataset.nptVideoResizeBound;
    if (typeof root.disconnectedCallback === 'function') {
      root.disconnectedCallback();
    }
    if (typeof root.connectedCallback === 'function') {
      root.connectedCallback();
    }
  }

  window.UgNexodeProTemplate = {
    init(root) {
      reinitRoot(root || document.querySelector(TAG_NAME));
    },
  };

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (!(container instanceof HTMLElement)) return;
    const root = container.querySelector(TAG_NAME);
    if (root instanceof HTMLElement) reinitRoot(root);
  });
})();
